var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _g2, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _g3, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _g4, _g5, _g6, _g7, _g8, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _g9, _g0, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWeeklyChallenge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 77,
    viewBox: "0 0 78 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.7918 12.8517L72.7588 23.5352L77.3991 23.4526L77.4999 29.1818C77.4999 29.1818 56.0481 67.0463 51.6349 76.7531C51.6349 76.7531 32.4184 72.6242 9.36176 71.6567L5.73715 67.5942L7.76839 65.7235L4.40288 56.9566L3.76782 53.4145L28.725 6.4324L71.8166 2.6863L71.961 10.8227L70.7918 12.8517Z",
    fill: "url(#paint0_linear_675_3719)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_675_3719",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 2,
    width: 75,
    height: 75
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7918 12.8517L72.7588 23.5352L77.3991 23.4526L77.4999 29.1818C77.4999 29.1818 56.0481 67.0463 51.6349 76.7531C51.6349 76.7531 32.4184 72.6242 9.36176 71.6567L5.73715 67.5942L7.76839 65.7235L4.40288 56.9566L3.76782 53.4145L28.725 6.4324L71.8166 2.6863L71.961 10.8227L70.7918 12.8517Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_675_3719)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M22.297 -0.608189C22.297 -0.608189 2.5853 39.2852 5.11862 43.428C7.61296 47.5042 24.5919 15.174 24.5919 15.174C24.5919 15.174 10.5566 44.3244 12.7506 50.0742C14.8942 55.6979 33.0355 9.84604 39.7437 2.03747C46.6306 -5.97973 43.1046 12.063 33.3955 31.699C24.3328 50.0283 52.3231 23.2967 52.6051 -14.0222C52.9284 -56.873 45.4614 -32.0259 45.4614 -32.0259C45.4614 -32.0259 56.1632 -16.771 48.2652 9.44942C41.0367 33.446 27.5035 44.6705 37.999 23.785C49.3404 1.21672 52.0572 -30.5518 32.655 12.0813C15.7769 49.1686 7.66111 58.3367 29.1931 4.9055C29.1931 4.9055 -8.92124 75.279 22.297 -0.608189Z",
    fill: "url(#paint1_linear_675_3719)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M53.554 -15.5307C53.554 -15.5307 59.3565 27.616 17.4227 58.2817C-20.3569 85.9097 18.5874 61.5784 18.5874 61.5784C18.5874 61.5784 56.2111 29.4065 54.7897 -10.691L57.8709 -5.28736C57.8709 -5.28736 61.0072 23.3059 23.0304 65.2351C-9.77431 101.456 25.5981 69.7034 25.5981 69.7034C25.5981 69.7034 56.8416 39.5099 59.8357 0.400566C63.3113 -44.9813 60.2575 1.62023 60.2575 1.62023C60.2575 1.62023 59.352 33.7945 29.0393 68.7542C2.28013 99.6149 29.0576 69.9166 29.0576 69.9166C29.0576 69.9166 55.4202 43.0428 61.076 6.15269C67.5847 -36.3039 82.0395 12.1203 46.8344 54.4301C16.4048 90.9993 68.9465 39.8607 69.5953 38.5654C70.2464 37.2632 86.0286 4.77483 86.0286 4.77483C86.0286 4.77483 67.94 -24.0912 66.5301 -25.696C65.111 -27.31 59.4391 -26.6612 59.4391 -26.6612L53.554 -15.5307Z",
    fill: "url(#paint2_linear_675_3719)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M14.9214 52.9812C14.9214 52.9812 26.0955 35.3466 32.3336 18.9866C38.9569 1.61106 43.2945 7.88131 33.3493 27.6756C24.0665 46.1516 19.3209 55.8149 19.3209 55.8149L17.4868 55.9043C17.4868 55.9043 29.7384 32.357 34.154 19.452C38.7827 5.92113 16.8426 54.1115 16.8426 54.1115L14.9214 52.9812Z",
    fill: "url(#paint3_linear_675_3719)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M22.3518 30.6513C22.3518 30.6513 41.832 -19.8178 50.1862 -22.6492C58.6069 -25.5035 52.2083 -29.2656 52.2083 -29.2656C52.2083 -29.2656 38.2143 -23.69 24.1561 21.4397C24.1561 21.4397 33.1247 -8.53827 46.8711 -23.4218C46.8711 -23.4195 33.2393 -0.449993 22.3518 30.6513Z",
    fill: "url(#paint4_linear_675_3719)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.28
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M39.7436 2.03978C33.2487 9.60075 15.9626 53.011 13.0051 50.4731C13.0235 50.535 13.0418 50.5969 13.0624 50.6542C15.1991 56.2642 33.345 10.5201 40.0486 2.72985C41.619 0.907235 42.6415 0.478519 43.1665 1.13879C42.8203 -0.358278 41.7084 -0.248233 39.7436 2.03978Z",
    fill: "url(#paint5_linear_675_3719)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M9.20827 37.0545C9.12803 34.6657 12.45 24.764 22.6268 0.0910587C22.6268 0.0910587 20.9693 3.43825 18.6744 8.28708C9.94191 29.9842 8.01154 37.0087 9.20827 37.0545Z",
    fill: "url(#paint6_linear_675_3719)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M24.908 15.8343C24.908 15.8343 24.7957 16.0659 24.5985 16.4831C17.127 35.6698 14.9834 43.3638 16.1733 43.1597C16.171 40.5943 19.8689 29.4477 29.5093 5.591C29.5093 5.591 28.6656 7.14309 27.3267 9.56636C26.3822 11.9392 25.5064 14.1584 24.6948 16.2401C24.8347 15.9787 24.908 15.8343 24.908 15.8343Z",
    fill: "url(#paint7_linear_675_3719)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M37.9964 23.7873C34.2938 31.1534 33.5304 34.5327 34.3603 34.9156C34.2571 33.6179 35.337 30.2983 38.2921 24.4246C44.7687 11.5655 48.4139 -4.15712 46.4835 -7.0733C47.6321 -2.82741 44.0557 11.7306 37.9964 23.7873Z",
    fill: "url(#paint8_linear_675_3719)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M61.0713 6.15269C55.4155 43.0428 29.053 69.9166 29.053 69.9166C29.053 69.9166 26.0267 73.2729 22.9845 76.6041C7.00967 95.1649 29.3327 70.4485 29.3327 70.4485C29.3327 70.4485 55.6792 43.632 61.3442 6.83129C63.5542 -7.51805 66.9702 -10.9822 68.6827 -7.10309C67.0894 -12.0711 63.4052 -9.06326 61.0713 6.15269Z",
    fill: "url(#paint9_linear_675_3719)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M59.8336 0.400572C56.8394 39.5099 25.5959 69.7034 25.5959 69.7034C25.5959 69.7034 11.3796 82.464 8.90817 83.1059C7.49135 86.7213 25.8825 70.2376 25.8825 70.2376C25.8825 70.2376 57.1054 40.1106 60.1155 1.09294C60.4778 -3.59771 60.7689 -7.28191 60.9982 -10.111C61.569 -19.5335 61.9359 -27.0532 59.8336 0.400572Z",
    fill: "url(#paint10_linear_675_3719)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M54.7919 -10.691C56.211 29.4088 18.5896 61.5784 18.5896 61.5784C18.5896 61.5784 4.56347 70.3407 1.20941 71.6223C-2.37392 75.3959 18.8876 62.1286 18.8876 62.1286C18.8876 62.1286 56.4815 30.0323 55.0831 -9.96884L57.8892 -5.04664C57.8777 -5.20483 57.8686 -5.28736 57.8686 -5.28736L54.7919 -10.691Z",
    fill: "url(#paint11_linear_675_3719)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M19.6193 56.3788C19.6193 56.3788 24.3649 46.7385 33.6476 28.3037C38.9802 17.7097 40.1953 10.9557 39.0811 9.81625C39.5328 12.0217 38.0196 18.3791 33.3496 27.6756C24.0669 46.1516 19.3212 55.8148 19.3212 55.8148L18.097 55.8745C17.8975 56.2596 17.7898 56.4682 17.7898 56.4682L19.6193 56.3788Z",
    fill: "url(#paint12_linear_675_3719)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M47.8545 40.9497C47.8545 40.9497 52.6781 33.0631 55.1472 27.2124C57.6163 21.3617 58.0795 18.1406 58.0795 18.1406C58.0795 18.1406 52.8913 30.3579 47.8545 40.9497Z",
    fill: "#74006F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M63.5564 29.5165C63.5564 29.5165 68.7927 20.5708 70.5969 14.4106L69.4873 14.4358C69.4873 14.4381 68.364 18.5969 63.5564 29.5165Z",
    fill: "#74006F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M12.019 46.2777C11.6453 45.0855 7.61267 29.5601 33.1636 -17.766C35.7611 -22.5781 37.8703 -26.3334 39.56 -29.1968C37.7396 -27.7112 35.9766 -25.9459 34.2572 -23.917L32.673 -18.0273C32.673 -18.0273 10.2881 21.9395 11.4344 43.9002C11.5032 44.3129 11.6362 45.1474 12.019 46.2777Z",
    fill: "#74006F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M71.5668 11.6985L76.317 -7.91697L50.7386 -25.9459C50.7386 -25.9459 51.2544 -30.2056 51.1673 -34.6188C48.9572 -34.2864 46.8412 -33.6101 44.8008 -32.6105C42.4508 -24.0156 35.032 -5.58999 35.032 -5.58999C35.032 -5.58999 16.8953 28.1295 12.9841 48.5427C13.1079 48.7857 13.2478 49.0356 13.3945 49.2901C14.3826 44.9617 20.4832 20.1398 35.5822 -5.12001C52.2013 -32.9223 44.9475 9.86439 44.9475 9.86439C44.9475 9.86439 25.1395 52.0642 21.8015 57.9126C21.994 58.0455 22.1958 58.1762 22.3952 58.3092C25.4971 51.7455 42.8039 15.1695 46.7632 8.01885C51.1192 0.157547 60.3056 11.7489 60.3056 11.7489C60.3056 11.7489 45.8691 50.5946 34.2136 63.1259C34.5139 63.158 34.8142 63.1809 35.1123 63.1993C39.0945 57.7773 52.5979 38.2582 61.2066 11.8773C71.3972 -19.3501 70.73 10.4284 70.73 10.4284C70.73 10.4284 58.538 48.2447 40.8277 65.4758C41.2197 65.3497 41.6095 65.2099 41.9969 65.0609C47.4487 58.9007 63.1919 37.9808 71.5668 11.6985Z",
    fill: "#74006F"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3449 29.0282C44.2848 26.9718 45.2225 25.0345 46.1052 23.4091L55.5392 18.5877L47.8108 19.1173C47.8108 19.1173 50.6124 13.9384 52.3891 11.6251C54.1659 9.3119 49.3446 12.9915 49.3446 12.9915C49.3446 12.9915 46.5407 20.6602 42.9437 29.0603C42.8336 29.0786 42.7236 29.1016 42.6158 29.136C41.1142 29.6128 40.8161 31.2887 41.2976 32.8225C40.8138 33.9046 40.3209 34.9821 39.8257 36.0413C39.3168 34.8904 38.8674 33.7555 38.5625 32.4419C38.159 30.7041 36.1989 28.4757 33.998 28.7141C31.7948 28.9548 32.8815 30.4542 30.018 32.1095C27.1523 33.7647 26.2375 34.8697 26.5379 36.7841C26.8382 38.6984 29.2913 38.0542 30.7769 37.7126C32.2602 37.371 32.6774 37.4787 32.6774 37.4787C34.4702 37.7584 34.7797 40.5347 37.6226 40.5393C36.7147 42.3046 35.816 43.9392 34.9494 45.3469C28.6241 55.6177 21.0242 43.1827 21.0242 43.1827C21.0242 43.1827 22.7711 39.1133 25.1279 33.9321C27.6681 34.0077 31.5678 28.0951 28.8282 27.1873C28.6631 27.1322 28.4934 27.0933 28.3238 27.0612C28.5943 26.4972 28.8626 25.9332 29.1354 25.3738C29.14 26.3734 29.7612 27.0566 30.5499 27.1575C33.3721 27.5151 36.5244 24.686 37.6363 22.0014C38.7482 19.3168 33.7229 19.5346 30.9328 22.1206C30.7952 22.249 30.6737 22.3751 30.5522 22.5012C32.1937 19.2297 33.7664 16.3135 35.0044 14.4588C39.6377 7.50534 33.5486 11.8475 33.5486 11.8475C33.5486 11.8475 31.2446 18.5877 27.73 26.997C24.7175 26.8938 21.4162 29.9773 23.9977 33.3337C24.2109 33.6111 24.4608 33.7808 24.7359 33.8679C23.0508 37.5635 21.2099 41.3211 19.2864 44.776L27.1683 50.8331L35.1511 49.3039L35.8206 47.4813C35.8206 47.4813 36.9187 44.5055 38.5212 40.4683C40.7015 40.1267 40.9858 38.5723 40.3439 37.1692C40.2545 36.9766 40.1719 36.7886 40.0848 36.5984C40.5319 35.514 40.9972 34.3998 41.4741 33.2856C42.1665 34.9087 43.7277 36.2017 45.6145 35.4429C49.1062 34.0329 46.1923 29.0534 43.3449 29.0282Z",
    fill: "#8D243F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4064 29.3354C40.8732 30.108 44.1378 27.7283 43.9888 24.1633C43.8398 20.5983 42.3657 19.8945 39.4839 22.2238C36.6021 24.5531 35.8134 28.5215 38.4064 29.3354Z",
    fill: "#8D243F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77894 42.096L10.2375 41.234C10.2375 41.234 13.2843 41.1583 13.9423 41.1675C14.6026 41.1767 18.9745 37.3457 18.9745 37.3457L19.119 35.8235C19.119 35.8235 17.9452 32.607 17.4752 32.0567C17.1153 31.6372 15.3454 31.4859 14.4306 31.612C13.5159 31.7381 9.21495 39.6819 8.91233 40.3743C8.60971 41.0689 9.77894 42.096 9.77894 42.096Z",
    fill: "url(#paint13_linear_675_3719)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M9.77894 42.096L10.2375 41.234C10.2375 41.234 13.2843 41.1583 13.9423 41.1675C14.6026 41.1767 18.9745 37.3457 18.9745 37.3457L19.119 35.8235C19.119 35.8235 14.3504 40.012 13.7772 40.0441C9.66203 40.2757 9.35022 39.4481 8.91233 40.3743C8.60971 41.0689 9.77894 42.096 9.77894 42.096Z",
    fill: "#C40040"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M14.2291 39.8195C14.0067 39.9547 14.0778 40.8144 14.1236 40.9153C14.1695 41.0139 18.9747 37.348 18.9747 37.348C18.9747 37.348 18.1104 38.7396 17.4364 39.51C16.7624 40.2803 14.5271 41.8943 13.6284 42.1831C12.732 42.4743 9.57738 42.472 9.57738 42.472L9.77683 42.0983C9.77683 42.0983 8.56175 41.0689 8.91023 40.3766C9.26099 39.6865 9.62095 39.9341 10.4211 39.996C11.2212 40.0579 13.5894 40.0648 13.7751 40.0464C13.9654 40.0281 14.2291 39.8195 14.2291 39.8195Z",
    fill: "#B21946"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7797 40.0464C14.3528 40.0143 19.1214 35.8257 19.1214 35.8257C19.1214 35.8257 17.9476 32.6092 17.4777 32.059C17.1177 31.6395 15.3478 31.4882 14.4331 31.6143C13.5183 31.7403 9.21742 39.6819 8.91479 40.3765C9.35268 39.4503 9.66449 40.278 13.7797 40.0464ZM11.2372 36.6029C11.4802 35.7501 13.3418 32.4671 14.4239 32.0315C15.8889 31.44 17.1911 32.1347 17.6931 32.8706C18.5093 34.0719 18.3672 35.2664 16.9137 37.3847C15.4602 39.5031 12.7182 39.9226 11.5994 39.9593C10.4829 39.996 10.7099 38.4554 11.2372 36.6029Z",
    fill: "#FFFF00"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M14.4811 35.8624C18.2478 36.5112 19.0021 35.64 18.2409 33.8495C17.4775 32.059 16.8677 31.589 15.0107 31.8183C13.1491 32.0476 12.6585 35.546 14.4811 35.8624Z",
    fill: "#FFF700"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.23 32.7216C17.2507 34.0994 18.1517 35.0646 18.5093 35.1105C18.867 35.1563 17.8009 32.5978 17.4937 32.2722C17.1888 31.9467 17.2254 32.3112 17.23 32.7216Z",
    fill: "#FFFFE0"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8141 2.68861C71.8141 2.68861 51.3803 40.5921 43.2049 53.4627L3.76538 53.4168L4.40043 56.9589L7.76595 65.7258L5.73471 67.5965L9.35931 71.659C9.35931 71.659 34.1147 72.9956 51.6325 76.7554C51.6325 76.7554 65.1725 50.5511 77.4975 29.1841L77.3966 23.4549L49.7548 72.6058L13.149 68.7841C13.149 68.7841 7.91039 64.2768 10.1021 56.9956L12.9954 56.9451L45.0252 58.0754L69.5903 18.0925L70.7871 12.8563L71.954 10.8296L71.8141 2.68861Z",
    fill: "#9F008D"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7917 12.8517L73.1622 24.7731L47.5586 69.3733L15.5883 67.1953C15.5883 67.1953 10.712 63.7656 13 56.9405L44.2939 56.936L53.9985 41.8025L70.7917 12.8517Z",
    fill: "url(#paint14_linear_675_3719)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M68.1256 37.9418L65.1063 38.9322L62.8733 36.9996L60.6884 30.7889L56.6351 37.2563L53.7258 42.2267C53.7258 42.2267 55.3856 45.8856 57.6576 45.5074C59.9296 45.1291 60.2001 47.3529 60.2001 47.3529L61.4863 47.33C61.4863 47.33 59.0423 51.7203 58.8039 52.4562C58.5655 53.1921 58.8223 53.4879 58.8223 53.4879L60.4248 53.6323L60.5348 59.8773L61.2226 58.4468L68.1256 37.9418Z",
    fill: "#8D3356"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M70.2943 26.2909C67.4653 28.329 53.2512 51.6676 49.2942 66.3769C53.8977 58.6944 66.2158 39.1019 73.1624 24.7754C72.979 24.4109 71.7066 25.2729 70.2943 26.2909Z",
    fill: "#B53356"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M66.4933 26.9809C69.0839 18.8239 71.6402 13.3033 70.785 13.661C70.7438 13.677 70.659 13.7641 70.5512 13.881L68.1463 17.4116L61.7156 28.4963C61.7156 28.5536 61.711 28.6018 61.7133 28.6614L59.2097 32.8889C59.2097 32.8889 59.196 32.8821 59.1776 32.8729L53.9964 41.8048L45.7981 54.5906L45.4817 55.2028C53.4278 53.4833 63.9027 35.138 66.4933 26.9809Z",
    fill: "#B53356"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5885 67.1976C15.5885 67.1976 11.7255 62.7316 13.3463 57.1721L12.9979 56.9428L39.5025 57.8782L45.5068 55.5375L4.06592 55.0881L4.40292 56.9612L7.76843 65.728L5.7372 67.5988L9.3618 71.6613C9.3618 71.6613 34.1172 72.9979 51.6349 76.7577L49.755 72.6081L13.1492 68.7864L15.5885 67.1976Z",
    fill: "#9F008D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "M38.4064 29.3354C40.8732 30.108 44.1378 27.7283 43.9888 24.1633C43.8398 20.5983 42.3657 19.8945 39.4839 22.2238C36.6021 24.5531 35.8134 28.5215 38.4064 29.3354Z",
    fill: "#9F008D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "M43.3449 29.0282C44.2848 26.9718 45.2225 25.0345 46.1052 23.4091L55.5392 18.5877L47.8108 19.1173C47.8108 19.1173 50.6124 13.9384 52.3891 11.6251C54.1659 9.3119 49.3446 12.9915 49.3446 12.9915C49.3446 12.9915 46.5407 20.6602 42.9437 29.0603C42.8336 29.0786 42.7236 29.1016 42.6158 29.136C41.1142 29.6128 40.8161 31.2887 41.2976 32.8225C40.8138 33.9046 40.3209 34.9821 39.8257 36.0413C39.3168 34.8904 38.8674 33.7555 38.5625 32.4419C38.159 30.7041 36.1989 28.4757 33.998 28.7141C31.7948 28.9548 32.8815 30.4542 30.018 32.1095C27.1523 33.7647 26.2375 34.8697 26.5379 36.7841C26.8382 38.6984 29.2913 38.0542 30.7769 37.7126C32.2602 37.371 32.6774 37.4787 32.6774 37.4787C34.4702 37.7584 34.7797 40.5347 37.6226 40.5393C36.7147 42.3046 35.816 43.9392 34.9494 45.3469C28.6241 55.6177 21.0242 43.1827 21.0242 43.1827C21.0242 43.1827 22.7711 39.1133 25.1279 33.9321C27.6681 34.0077 31.5678 28.0951 28.8282 27.1873C28.6631 27.1322 28.4934 27.0933 28.3238 27.0612C28.5943 26.4972 28.8626 25.9332 29.1354 25.3738C29.14 26.3734 29.7612 27.0566 30.5499 27.1575C33.3721 27.5151 36.5244 24.686 37.6363 22.0014C38.7482 19.3168 33.7229 19.5346 30.9328 22.1206C30.7952 22.249 30.6737 22.3751 30.5522 22.5012C32.1937 19.2297 33.7664 16.3135 35.0044 14.4588C39.6377 7.50534 33.5486 11.8475 33.5486 11.8475C33.5486 11.8475 31.2446 18.5877 27.73 26.997C24.7175 26.8938 21.4162 29.9773 23.9977 33.3337C24.2109 33.6111 24.4608 33.7808 24.7359 33.8679C23.0508 37.5635 21.2099 41.3211 19.2864 44.776L27.1683 50.8331L35.1511 49.3039L35.8206 47.4813C35.8206 47.4813 36.9187 44.5055 38.5212 40.4683C40.7015 40.1267 40.9858 38.5723 40.3439 37.1692C40.2545 36.9766 40.1719 36.7886 40.0848 36.5984C40.5319 35.514 40.9972 34.3998 41.4741 33.2856C42.1665 34.9087 43.7277 36.2017 45.6145 35.4429C49.1062 34.0329 46.1923 29.0534 43.3449 29.0282Z",
    fill: "#9F008D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "M46.1051 23.4068L51.8251 20.4837L48.3587 21.2632L47.8107 19.1151C47.8107 19.1151 50.5733 14.0072 52.3524 11.671L50.1561 12.6156L43.2324 29.0259L43.4823 30.7706C42.3223 31.197 41.6735 33.6616 42.955 35.1632C43.6932 35.663 44.6057 35.8441 45.6099 35.4406C46.199 35.2045 46.6048 34.8652 46.8616 34.4663C46.8662 34.4594 46.8708 34.4525 46.8731 34.4456C46.8822 34.4296 46.8891 34.4135 46.8983 34.3998C47.9712 32.5336 45.5778 30.8967 44.1426 30.7156L43.3448 29.0282C44.2824 26.9718 45.2224 25.0345 46.1051 23.4068Z",
    fill: "#9F008D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "M41.0157 33.7143L39.8625 36.6052C39.2412 35.7432 38.448 34.9798 38.3036 34.3654C38.0468 33.2741 36.912 32.2402 35.6992 31.7885C34.4887 31.3369 34.2365 32.9967 32.4414 33.5217C30.6463 34.0467 28.1634 34.7162 27.7966 35.796C27.5146 36.6282 27.7232 37.8043 28.8191 38.0702C29.4954 38.0106 30.2061 37.8364 30.7747 37.7057C32.258 37.3641 32.6752 37.4718 32.6752 37.4718C34.468 37.7515 34.7776 40.5279 37.6204 40.5325L37.8565 41.4908L34.5483 47.0893L35.7588 47.6257L35.8138 47.4767C35.8138 47.4767 36.9119 44.5009 38.5145 40.4637C38.542 40.4591 38.5649 40.4522 38.5901 40.4476C39.89 40.2207 40.4953 39.5535 40.6122 38.7465C40.6374 38.5585 40.6283 38.3751 40.6007 38.1917L40.6237 38.1803C40.5893 37.8455 40.4907 37.5017 40.3371 37.1646C40.2477 36.9721 40.1651 36.7841 40.078 36.5938C40.5251 35.5094 40.9905 34.3952 41.4673 33.281L41.0157 33.7143Z",
    fill: "#9F008D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "M29.1997 30.4817C29.2684 30.3419 29.3372 30.1997 29.4014 30.0553C29.406 30.0416 29.4129 30.0301 29.4175 30.0163C29.7476 29.2575 29.3923 28.9044 28.7549 28.8196L28.3193 27.0566L29.1309 25.3692L30.3597 26.1075C30.3368 26.7265 30.6463 27.1598 31.2172 27.1735C33.3034 27.0818 35.4607 25.4449 36.779 23.5352C38.1087 21.5819 35.9284 21.066 32.9366 22.8107C31.7238 23.5191 30.9833 24.3697 30.6211 25.1308L30.5431 22.4966C32.1846 19.2251 33.7573 16.3089 34.9953 14.4542C35.3438 13.9315 35.6258 13.4799 35.8597 13.0787L33.7184 12.9869L27.941 27.0062L28.1818 28.8081C27.4115 28.8586 26.4669 29.1406 25.7677 29.5165C24.1972 30.3579 22.9111 32.7995 24.4678 33.7533C24.5503 33.8014 24.6374 33.8358 24.7268 33.8633C24.7245 33.8633 24.9056 34.0994 24.9056 34.0994L20.4053 43.3203L21.226 43.4991C21.0908 43.295 21.0174 43.1758 21.0174 43.1758C21.0174 43.1758 22.7644 39.1065 25.1212 33.9252C25.1349 33.9252 25.1509 33.9229 25.167 33.9229C26.5517 33.9298 28.3147 32.2058 29.1997 30.4817Z",
    fill: "#9F008D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "M40.6808 29.2437C42.4966 28.6018 44.0945 26.6806 43.989 24.1633C43.9569 22.3155 41.8775 22.6113 39.7225 24.7342C37.5789 26.8457 38.5991 29.7504 40.6808 29.2437Z",
    fill: "#9F008D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9668 21.3205C29.4587 22.9551 35.103 25.2615 36.7812 23.5352C38.4594 21.8111 38.4066 20.1742 36.396 20.1123C34.3877 20.0504 33.3767 20.4012 31.9668 21.3205Z",
    fill: "url(#paint15_linear_675_3719)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5738 23.0193C36.9507 24.5599 41.8179 25.3348 43.0123 24.8557C44.2067 24.3765 44.2274 23.3082 43.5075 21.763C42.7876 20.2155 41.059 20.6579 38.5738 23.0193Z",
    fill: "url(#paint16_linear_675_3719)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M41.341 30.2387C40.8595 31.7197 47.6135 36.1926 47.2077 33.1251C46.8019 30.0576 44.3168 28.9961 43.2301 29.0236C42.1411 29.0534 41.5336 29.6449 41.341 30.2387Z",
    fill: "url(#paint17_linear_675_3719)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3618 27.538C23.663 28.329 28.3215 31.9238 29.1996 30.4817C30.0754 29.0397 29.9722 27.8452 29.1446 27.3317C28.2619 26.7861 27.1088 26.7242 25.3618 27.538Z",
    fill: "url(#paint18_linear_675_3719)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3307 33.1847C25.9418 35.1769 31.6389 35.6309 33.019 33.3795C34.3968 31.1259 32.102 30.0392 28.3307 33.1847Z",
    fill: "url(#paint19_linear_675_3719)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2271 28.7623C32.6429 28.9159 35.3299 33.5194 37.3909 34.3379C39.4519 35.1563 38.9361 32.3318 38.0328 31.1649C37.1272 30.0003 36.4142 28.5491 34.2271 28.7623Z",
    fill: "url(#paint20_linear_675_3719)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6993 35.7501C38.4039 34.3929 33.0462 37.3411 34.7129 39.1592C36.3796 40.9772 37.9386 40.8121 39.7016 40.0762C41.4646 39.3403 40.3733 36.4562 39.6993 35.7501Z",
    fill: "url(#paint21_linear_675_3719)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M23.1402 30.2226C23.1883 29.998 23.2617 29.7825 23.3557 29.5738C23.3832 29.5119 23.4061 29.45 23.4382 29.3881C23.4818 29.3056 23.5299 29.2277 23.5803 29.1474C23.6216 29.0809 23.6629 29.0145 23.7064 28.9503C23.7569 28.8792 23.8119 28.8104 23.8669 28.7416C23.9219 28.6751 23.977 28.6087 24.0366 28.5445C24.0916 28.4849 24.1489 28.4253 24.2085 28.3656C24.2796 28.2969 24.3529 28.2327 24.4286 28.1662C24.4836 28.118 24.5386 28.0699 24.5982 28.0263C24.6968 27.9507 24.7977 27.8796 24.9032 27.8131C24.9444 27.7856 24.9857 27.7558 25.0293 27.7283C25.341 27.538 25.6735 27.3798 26.0219 27.2606C26.0495 27.2514 26.077 27.2446 26.1045 27.2354C26.2512 27.1873 26.4002 27.146 26.5515 27.1116C26.5905 27.1024 26.6295 27.0955 26.6685 27.0887C26.8106 27.0589 26.9527 27.0382 27.0972 27.0222C27.1384 27.0176 27.1774 27.013 27.2187 27.0107C27.3654 26.9993 27.5121 26.9947 27.6589 26.997C27.6818 26.997 27.7047 26.9947 27.7276 26.9947C27.8354 26.7379 27.9409 26.4811 28.0463 26.2289C25.5841 26.0799 22.9017 28.1089 23.0714 30.7752C23.0737 30.7178 23.0851 30.6628 23.0897 30.6055C23.0989 30.5046 23.1058 30.4015 23.1241 30.3029C23.1241 30.2754 23.1333 30.2502 23.1402 30.2226Z",
    fill: "#B21946"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M36.9024 26.2977C36.9115 26.2473 36.9253 26.1945 36.9367 26.1441C36.9665 26.0088 36.9987 25.8736 37.0399 25.7337C37.0606 25.6673 37.0858 25.6008 37.1064 25.5343C37.15 25.4105 37.1935 25.2844 37.2463 25.1606C37.2761 25.0872 37.3104 25.0139 37.3448 24.9405C37.3998 24.8213 37.4595 24.7021 37.5214 24.5829C37.5626 24.5072 37.6039 24.4315 37.6475 24.3559C37.7162 24.239 37.7873 24.1243 37.863 24.0097C37.9134 23.9341 37.9615 23.8607 38.0143 23.785C38.0968 23.6704 38.1862 23.5558 38.2756 23.4434C38.3307 23.3747 38.3857 23.3036 38.443 23.2348C38.5462 23.1156 38.6562 22.9987 38.7685 22.884C38.8236 22.8267 38.874 22.7694 38.9313 22.7121C39.1033 22.5447 39.2821 22.3843 39.4724 22.2284C39.8369 21.9326 40.1762 21.6896 40.4926 21.4924C40.8089 21.2953 41.1024 21.1463 41.3775 21.0431C43.0144 20.4264 43.8719 21.4901 43.9842 24.1633C43.9934 24.3719 43.9888 24.576 43.9727 24.7777C43.9681 24.8442 43.959 24.9061 43.9521 24.9726C43.9383 25.1056 43.9223 25.2385 43.8994 25.3669C43.8856 25.4403 43.8695 25.5136 43.8512 25.5847C43.826 25.6993 43.7962 25.814 43.7618 25.9263C43.7389 25.9997 43.716 26.0707 43.6907 26.1441C43.6541 26.2496 43.6128 26.355 43.5692 26.4559C43.5394 26.5247 43.5096 26.5957 43.4775 26.6622C43.4294 26.7631 43.379 26.8571 43.3239 26.9534C43.2895 27.0176 43.2551 27.0818 43.2162 27.1437C43.1543 27.2423 43.0878 27.3363 43.0213 27.4303C42.9846 27.4807 42.9525 27.5357 42.9135 27.5862C42.8127 27.7191 42.7049 27.8429 42.5949 27.9644C42.533 28.0332 42.4642 28.0928 42.4 28.157C42.345 28.2097 42.29 28.2648 42.2327 28.3152C42.157 28.3817 42.0813 28.4413 42.0034 28.5032C41.9507 28.5445 41.9002 28.5857 41.8475 28.6224C41.7627 28.682 41.6778 28.7393 41.5907 28.7943C41.5426 28.8242 41.4944 28.854 41.4463 28.8815C41.3523 28.9365 41.2583 28.9869 41.162 29.0351C41.1207 29.0557 41.0818 29.0718 41.0405 29.0924C40.935 29.1405 40.8296 29.1864 40.7195 29.2276C40.7012 29.2345 40.6805 29.2391 40.6622 29.246C40.261 29.3858 39.8529 29.4661 39.4471 29.4752C41.8521 29.5188 44.4908 27.0245 44.3464 23.487C44.1836 19.4658 42.6315 18.6703 39.603 21.293C37.785 22.8657 36.7694 25.101 36.8313 26.8411C36.8473 26.6645 36.8703 26.4811 36.9024 26.2977Z",
    fill: "#B21946"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M41.2105 30.5918C41.2151 30.5734 41.2242 30.5574 41.2288 30.5413C41.2701 30.4083 41.3251 30.2823 41.387 30.1607C41.4031 30.1286 41.4191 30.0966 41.4374 30.0667C41.5131 29.9361 41.6002 29.8123 41.7034 29.6999C41.7126 29.6908 41.724 29.6816 41.7355 29.6724C41.8318 29.5738 41.9418 29.4844 42.0587 29.4065C42.0931 29.3836 42.1275 29.3606 42.1619 29.34C42.2995 29.2575 42.4485 29.1864 42.6158 29.1314C42.7236 29.097 42.8336 29.0741 42.9437 29.0557C43.0377 28.8379 43.1294 28.6178 43.2234 28.4C43.056 28.4184 42.8886 28.4482 42.7259 28.5009C41.4856 28.9021 41.011 30.0736 41.089 31.3575C41.0913 31.2887 41.1004 31.2222 41.1073 31.1557C41.1096 31.1282 41.1119 31.1007 41.1142 31.0732C41.1325 30.9081 41.1646 30.7477 41.2105 30.5918Z",
    fill: "#B21946"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M30.9188 22.1252C31.1114 21.9464 31.3132 21.7951 31.5149 21.6461C32.409 20.9812 33.4384 20.5158 34.4128 20.2751C34.4976 20.2544 34.5824 20.2338 34.665 20.2155C35.0272 20.1398 35.3802 20.094 35.7058 20.0825C35.7172 20.0825 35.731 20.0802 35.7425 20.0802C36.2927 20.0642 36.7741 20.1421 37.1318 20.3141C37.4894 20.486 37.7233 20.7565 37.7783 21.1256C37.815 21.3709 37.7714 21.6621 37.6316 21.9968C37.5651 22.155 37.4917 22.3132 37.4138 22.4714C37.3885 22.5241 37.3587 22.5746 37.3312 22.6273C37.2762 22.7327 37.2189 22.8405 37.157 22.946C37.1203 23.0079 37.0836 23.0675 37.0447 23.1294C36.9851 23.2256 36.9254 23.3196 36.8635 23.4136C36.82 23.4778 36.7764 23.542 36.7306 23.6062C36.6664 23.6956 36.6022 23.785 36.5334 23.8745C36.4853 23.9386 36.4371 24.0028 36.3867 24.0647C36.3179 24.1519 36.2445 24.239 36.1712 24.3238C36.1184 24.3857 36.068 24.4453 36.0153 24.5049C35.9351 24.5943 35.8525 24.6792 35.77 24.7663C35.7195 24.819 35.6691 24.874 35.6164 24.9268C35.4926 25.0506 35.3642 25.1721 35.2312 25.2913C35.1762 25.3417 35.1189 25.3876 35.0616 25.4357C34.9653 25.5182 34.8713 25.6008 34.7727 25.6764C34.7039 25.7315 34.6328 25.7819 34.5641 25.8323C34.4815 25.8942 34.4013 25.9538 34.3165 26.0111C34.2408 26.0639 34.1629 26.112 34.0872 26.1625C34.007 26.2129 33.9267 26.2633 33.8465 26.3115C33.7662 26.3596 33.686 26.4055 33.6035 26.449C33.5232 26.4926 33.443 26.5339 33.3627 26.5751C33.2802 26.6164 33.1977 26.6554 33.1152 26.6943C33.0326 26.731 32.9501 26.7631 32.8675 26.7975C32.785 26.8319 32.7002 26.864 32.6177 26.8938C32.5328 26.9236 32.4457 26.9465 32.3609 26.9717C32.2783 26.9947 32.1981 27.0222 32.1156 27.0428C31.9574 27.0818 31.8015 27.1116 31.6433 27.1345C34.3577 26.825 37.1295 23.9295 38.1818 21.1554C39.2112 18.4387 35.2794 18.2828 32.2852 20.2705L35.8617 13.074C35.6278 13.4752 35.3458 13.9269 34.9974 14.4496C33.9474 16.0269 32.652 18.3722 31.2788 21.0477C31.0358 21.5223 30.7905 22.0014 30.5452 22.492C30.6644 22.3751 30.7859 22.2513 30.9188 22.1252Z",
    fill: "#B21946"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M41.4668 33.2833C41.1114 34.1178 40.763 34.9454 40.4214 35.7661C40.3067 36.0435 40.1898 36.321 40.0775 36.5961C40.1646 36.7863 40.2471 36.9743 40.3365 37.1669C40.3778 37.2586 40.4168 37.3526 40.4512 37.4466C40.4649 37.481 40.4741 37.5177 40.4856 37.5521C40.5039 37.6094 40.5245 37.669 40.5383 37.7263C40.5497 37.7699 40.5589 37.8134 40.5681 37.8547C40.5796 37.9028 40.591 37.9533 40.5979 38.0014C40.6071 38.0496 40.6116 38.0977 40.6185 38.1459C40.6231 38.1871 40.6277 38.2307 40.63 38.272C40.6346 38.3247 40.6346 38.3774 40.6346 38.4301C40.6346 38.4645 40.6346 38.4989 40.6323 38.5333C40.63 38.5906 40.6254 38.6479 40.6185 38.703C40.6162 38.7282 40.6116 38.7557 40.607 38.7809C40.5979 38.8428 40.5841 38.9047 40.5681 38.9666C40.5635 38.9804 40.5589 38.9964 40.5543 39.0102C40.4053 39.5191 40.0293 39.9524 39.3782 40.2252C39.2613 40.2734 39.1375 40.3169 39.0045 40.3559C38.9908 40.3605 38.9793 40.3651 38.9656 40.3674C38.8257 40.4064 38.6767 40.4407 38.5139 40.466C38.4589 40.6035 38.4085 40.7342 38.3557 40.8695C36.8403 44.6981 35.8155 47.479 35.8155 47.479L35.6367 47.9673L35.8729 48.1828L39.4974 40.7204C41.4759 40.2367 41.7121 38.6548 41.0656 37.2174C40.967 36.9973 40.8753 36.7841 40.779 36.5686L41.7763 33.8839C41.6571 33.6913 41.5562 33.4896 41.4668 33.2833Z",
    fill: "#B21946"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M29.1717 26.4674L29.2932 26.1716C29.1946 25.9355 29.1327 25.6719 29.1304 25.3715C28.9356 25.7727 28.7407 26.1808 28.5481 26.5866C28.4725 26.7448 28.3968 26.9007 28.3211 27.0589C28.4931 27.091 28.6605 27.1299 28.8255 27.185C28.9906 27.24 29.1281 27.3133 29.2474 27.4005C29.2497 27.4028 29.2542 27.405 29.2588 27.4073C29.3734 27.4945 29.4652 27.5976 29.5385 27.7123C29.5431 27.7191 29.5477 27.7237 29.55 27.7283C29.621 27.8406 29.6715 27.969 29.7059 28.1043C29.7082 28.1135 29.7127 28.1226 29.715 28.1318C29.7471 28.2671 29.7609 28.4115 29.7609 28.5628C29.7609 28.5766 29.7632 28.588 29.7609 28.6018C29.7586 28.7531 29.7403 28.9113 29.7105 29.0741C29.7082 29.0901 29.7059 29.1062 29.7013 29.1245C29.6692 29.2873 29.6233 29.4546 29.566 29.6243C29.5592 29.6449 29.5546 29.6633 29.5477 29.6839C29.4904 29.8535 29.4193 30.0232 29.3414 30.1951C29.3299 30.2181 29.3207 30.241 29.3093 30.2639C29.229 30.4336 29.1396 30.6055 29.041 30.7752C29.0273 30.8004 29.0112 30.8256 28.9975 30.8508C28.8989 31.0182 28.7934 31.1832 28.6811 31.346C28.6628 31.3735 28.6421 31.401 28.6238 31.4286C28.5114 31.589 28.3922 31.7449 28.2707 31.8962C28.2478 31.9238 28.2249 31.9536 28.2019 31.9811C28.0781 32.1301 27.952 32.2722 27.8191 32.4121C27.7916 32.4396 27.7663 32.4671 27.7388 32.4946C27.6081 32.6276 27.4729 32.756 27.3376 32.8752C27.3078 32.9004 27.278 32.9256 27.2505 32.9508C27.1152 33.0678 26.9777 33.1755 26.8378 33.2741C26.808 33.297 26.7759 33.3177 26.7461 33.3383C26.6086 33.4323 26.4687 33.5171 26.3312 33.5905C26.2578 33.6294 26.1844 33.657 26.1134 33.6891C26.0308 33.7257 25.9483 33.7647 25.8658 33.7922C25.797 33.8151 25.7282 33.8335 25.6617 33.8495C25.5769 33.8725 25.4898 33.8885 25.4073 33.9C25.3133 33.9114 25.2193 33.9252 25.1298 33.9229C22.7731 39.1019 21.0261 43.1735 21.0261 43.1735C21.0261 43.1735 21.0995 43.2927 21.2347 43.4968L26.698 33.4277C29.0731 31.9169 31.4253 27.3707 29.1717 26.4674Z",
    fill: "#B21946"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M44.4566 28.5582L47.1756 22.8611L46.105 23.4068C45.2224 25.0345 44.2824 26.9718 43.3447 29.0259C43.6175 29.0282 43.8926 29.0878 44.1609 29.1749C44.9426 29.4157 45.674 29.9819 46.2265 30.6858C46.2311 30.6926 46.2357 30.6972 46.2403 30.7041C46.3572 30.8554 46.4672 31.0136 46.5658 31.1741C46.5727 31.1855 46.5796 31.1993 46.5888 31.2108C46.685 31.3712 46.7722 31.534 46.8478 31.6991C46.8547 31.7128 46.8593 31.7266 46.8661 31.7404C46.9418 31.9077 47.006 32.0774 47.0587 32.247C47.061 32.2539 47.0633 32.2631 47.0656 32.2699C47.116 32.4419 47.155 32.6161 47.1802 32.7881C47.1802 32.7927 47.1825 32.7972 47.1825 32.8018C47.2055 32.9669 47.2123 33.132 47.2077 33.2947C47.2077 33.3131 47.2077 33.3337 47.2077 33.3543C47.2009 33.5079 47.1756 33.6593 47.1412 33.806C47.1344 33.8312 47.1298 33.8541 47.1229 33.8793C47.0839 34.0215 47.0289 34.1613 46.9602 34.2943C46.9487 34.3172 46.9349 34.3402 46.9212 34.3631C46.8478 34.4938 46.7584 34.6199 46.6529 34.7391C46.6369 34.7574 46.6185 34.7757 46.6002 34.7941C46.4856 34.9133 46.3572 35.0256 46.2082 35.1288C46.1921 35.1403 46.1738 35.1494 46.16 35.1586C45.9973 35.2641 45.8184 35.3604 45.6144 35.4429C45.4631 35.5025 45.3186 35.5461 45.1719 35.5805C45.1513 35.585 45.1306 35.5896 45.11 35.5942C44.9702 35.624 44.8326 35.6446 44.6997 35.6538C45.0986 35.6653 45.5181 35.5942 45.9537 35.4154C49.3215 34.0329 47.1504 29.5028 44.4566 28.5582Z",
    fill: "#B21946"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M36.3016 29.3262C36.5308 29.4753 36.7486 29.6472 36.9527 29.8329C37.1567 30.0186 37.347 30.2203 37.5189 30.4313C38.0393 31.064 38.4085 31.7862 38.5598 32.4373C38.6515 32.8316 38.7592 33.2076 38.8761 33.5767C38.9128 33.6913 38.9495 33.8014 38.9885 33.9137C39.0779 34.1751 39.1696 34.4341 39.2682 34.6886C39.3094 34.7964 39.3507 34.9064 39.3943 35.0142C39.5181 35.3214 39.6464 35.6263 39.7817 35.9335C39.7978 35.9679 39.8115 36.0023 39.8253 36.0367C39.9514 35.7684 40.0729 35.4933 40.1967 35.2228C39.7886 34.2278 39.4264 33.2191 39.1696 32.0865C38.7386 30.202 36.65 27.781 34.3047 28.0424C31.9594 28.3014 33.1171 29.9292 30.0657 31.7243C27.0142 33.5194 26.0376 34.7184 26.3609 36.7955C26.6818 38.8726 29.2954 38.1734 30.8773 37.8042C32.4592 37.4351 32.9016 37.5498 32.9016 37.5498C32.9681 37.5612 33.0277 37.5819 33.0919 37.5979C32.9613 37.5429 32.826 37.497 32.677 37.4741C32.677 37.4741 32.5715 37.4466 32.2826 37.4627C32.2781 37.4627 32.2712 37.4627 32.2666 37.4649C32.1313 37.4718 31.9548 37.4902 31.7324 37.5246C31.4779 37.5635 31.1661 37.6208 30.7764 37.7103C30.6641 37.7355 30.5449 37.763 30.4233 37.7928C30.2629 37.8295 30.0955 37.8662 29.9236 37.9028C29.8869 37.9097 29.8502 37.9189 29.8112 37.9258C28.4104 38.2077 26.7804 38.3224 26.5374 36.784C26.5007 36.5456 26.4801 36.3187 26.4824 36.1009C26.4847 35.851 26.5168 35.6171 26.5764 35.3901C26.6085 35.2641 26.6497 35.1425 26.7002 35.0233C27.1151 34.0352 28.1491 33.1893 30.0176 32.1094C30.2491 31.9765 30.4463 31.8435 30.6297 31.7128C30.7948 31.5936 30.9438 31.4767 31.0767 31.3621C31.1959 31.2589 31.3037 31.158 31.4 31.0571C31.4963 30.9586 31.5834 30.86 31.6614 30.7637C31.7714 30.6284 31.8723 30.4955 31.9548 30.3694C32.0923 30.163 32.2001 29.9705 32.3079 29.7939C32.3858 29.6632 32.4638 29.5395 32.5486 29.4271C32.8283 29.0557 33.1928 28.7989 33.9975 28.7118C34.2726 28.682 34.5454 28.6912 34.8091 28.7325C35.075 28.7737 35.3341 28.8471 35.584 28.9503C35.8316 29.0488 36.0723 29.1772 36.3016 29.3262Z",
    fill: "#B21946"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M49.4041 16.2883L48.8379 18.4135L55.5391 18.5855L47.8108 19.1128L49.4041 16.2883Z",
    fill: "#B21946"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M5.73729 67.5965L9.6347 67.5277L13.1515 68.7841L9.09824 66.5144L6.6681 58.582L12.8191 63.2085C12.8191 63.2085 12.6472 61.0328 13.8302 59.8292C13.8302 59.8292 42.6458 61.1314 44.1382 61.2575C45.6307 61.3836 46.4194 63.385 46.4194 63.385L45.5528 58.6096L5.02889 56.5623L4.63916 57.5802L7.76623 65.7235L5.73729 67.5965Z",
    fill: "#B53356"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M44.294 56.9382L13.0001 56.9428C9.95098 62.7362 15.1506 67.4842 15.1506 67.4842L47.561 69.3756L46.903 66.6795L38.9454 66.347L46.8938 65.8633L44.991 55.8539L44.294 56.9382Z",
    fill: "#B53356"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M29.4519 66.1178C37.6663 66.4777 45.8852 61.0099 45.5551 58.6095L45.3717 57.9355C45.3717 57.9355 13.3487 57.2042 12.3308 57.1904C12.9131 58.8365 20.8249 65.7395 29.4519 66.1178Z",
    fill: "#B53356"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M14.9006 63.1718C14.9006 63.1718 29.3669 63.3804 33.7595 64.3341C33.7595 64.3341 22.2071 65.5423 14.9006 63.1718Z",
    fill: "#8D3356"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M23.418 60.8196C23.418 60.8196 35.3578 60.5376 41.7908 62.092C41.7908 62.092 28.4204 61.4179 23.418 60.8196Z",
    fill: "#8D3356"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M58.4944 39.7736L46.4744 57.1858C46.4744 57.1858 54.3425 48.0452 58.4944 39.7736Z",
    fill: "#B53356"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M69.6248 23.4778L55.5391 46.0599C55.5368 46.0599 65.6357 33.0563 69.6248 23.4778Z",
    fill: "#B53356"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0938 63.4331C19.0938 63.4331 22.8193 63.3965 24.0252 63.518C25.2311 63.6395 25.7515 63.9467 25.7515 63.9467L23.1288 66.2851L17.2437 66.0742L16.9136 64.9348L19.0938 63.4331Z",
    fill: "#BF0018"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "M16.9136 64.9325L22.6175 65.054L24.5708 63.5913C24.5708 63.5913 25.3503 63.6303 25.7515 63.9444L23.1288 66.2828L17.2437 66.0719L16.9136 64.9325Z",
    fill: "#9F008D"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M62.7126 34.5556C62.7126 34.5556 64.909 32.2814 65.6357 31.2199C66.3625 30.1607 69.1823 24.1816 69.1823 24.1816L62.7126 34.5556Z",
    fill: "#7B0C3B"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8311 31.236L68.795 25.0139L70.4571 24.9863L70.2255 26.5338L67.2131 31.1947L64.8311 31.236Z",
    fill: "#BF0018"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "M70.4571 24.9863L66.7958 30.2272L65.4592 30.2501L64.8311 31.236L67.2131 31.1947L70.2255 26.5338L70.4571 24.9863Z",
    fill: "#9F008D"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1265 66.2851L22.6175 65.054L16.9136 64.9325L17.2437 66.0742L23.1265 66.2851Z",
    fill: "#B000B3"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M29.021 61.0649C29.021 61.0649 32.7534 61.0259 33.996 61.1382C35.2385 61.2506 35.8438 61.5372 35.8438 61.5372L33.8194 63.7266L27.8518 63.5363L27.2236 62.4702L29.021 61.0649Z",
    fill: "#322BB0"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M27.2212 62.4703L32.9847 62.5757L34.5643 61.207C34.5643 61.207 35.3576 61.2414 35.8413 61.5349L33.817 63.7243L27.8494 63.534L27.2212 62.4703Z",
    fill: "#6545A4"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M33.817 63.7243L32.9847 62.5757L27.2212 62.4703L27.8517 63.534L33.817 63.7243Z",
    fill: "#6545A4"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7958 30.2272L67.2131 31.1947L64.8311 31.236L65.4592 30.2501L66.7958 30.2272Z",
    fill: "#B000B3"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5029 15.9719L22.8468 17.5607L23.3672 16.5817L24.1765 16.5703C24.1765 16.5703 26.5516 9.9653 31.9805 8.95197C31.9805 8.95197 32.3428 16.3846 39.3925 16.5748C47.9461 16.8064 51.9398 13.0122 54.386 8.78461C54.386 8.78461 63.5083 6.04038 63.1735 16.2287L64.462 16.2057L64.9824 22.719L64.4001 23.7232L65.7114 23.7002L72.7635 10.8686C72.7635 10.8686 72.9423 1.58128 72.5892 1.01272C72.2362 0.44645 56.7291 1.89078 56.3279 1.89766C55.9267 1.90454 55.6653 3.342 55.028 2.89494C54.3906 2.44789 54.2668 1.93434 54.2668 1.93434C54.2668 1.93434 40.2843 2.01458 36.8592 2.87889C36.8592 2.87889 36.3089 3.74778 35.7312 3.75925C35.1558 3.76842 35.3139 3.02103 34.7958 2.91557C34.2777 2.81011 28.2115 3.34658 28.2115 3.34658L22.5029 15.9719Z",
    fill: "url(#paint22_linear_675_3719)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8472 42.2427C44.129 50.8674 36.9509 50.1338 36.9509 50.1338C36.9509 50.1338 37.4622 40.9268 28.4248 40.6287C19.3873 40.3307 15.1208 49.0448 15.1208 49.0448C9.24491 48.921 9.59109 42.4536 9.59109 42.4536L9.33891 41.1675L8.0069 41.1904C8.0069 41.1904 0.402369 52.7588 0.50095 53.4031C0.597239 54.0473 2.20433 57.2844 2.80728 57.4449C3.41253 57.6054 12.7296 57.869 12.7296 57.869C12.7686 56.5875 14.2909 57.8438 14.6806 57.9218C15.0681 57.9997 31.2011 58.66 31.2011 58.66C32.3267 56.7067 33.3515 58.7219 33.6541 58.8457C33.9568 58.9695 44.0281 59.7214 44.881 59.3638C45.7338 59.0039 50.711 48.5703 50.711 48.5703L50.5964 42.1533L48.8472 42.2427Z",
    fill: "url(#paint23_linear_675_3719)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5178 43.1024C62.5178 43.1024 60.2803 45.2047 58.4714 42.3023C56.3576 38.9093 61.1285 41.085 61.1285 41.085C61.1285 41.085 60.8351 42.7471 62.5178 43.1024Z",
    fill: "url(#paint24_linear_675_3719)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M61.3761 42.3688C61.007 41.7819 61.1262 41.0873 61.1262 41.0873C61.1262 41.0873 56.353 38.9093 58.4691 42.3046C59.6727 44.2373 61.0643 43.9507 61.8621 43.5426C61.7773 43.5701 61.7016 43.6022 61.6008 43.6252C60.952 43.7788 60.4636 43.5197 60.2687 42.8273C60.2642 42.8182 60.2642 42.809 60.2596 42.7998C60.2504 42.77 60.2413 42.7425 60.2344 42.7104C60.2115 42.323 60.8534 41.9103 61.3761 42.3688Z",
    fill: "#B21946"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M60.4086 42.9832C59.8561 42.5912 60.7204 41.7957 61.3761 42.3688C61.007 41.7819 61.1262 41.0873 61.1262 41.0873C61.1262 41.0873 56.353 38.9093 58.4691 42.3046C60.2779 45.2093 62.5155 43.1047 62.5155 43.1047C61.2752 43.4257 60.9611 43.3753 60.4086 42.9832Z",
    fill: "#C40040"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1533 29.8765C62.362 29.4294 62.4926 29.113 62.5041 28.9915C62.5775 28.2166 61.1446 23.785 59.7255 23.808C58.3064 23.8309 49.5991 27.2148 49.606 27.6343C49.6128 28.0538 49.8559 29.6174 49.8582 29.6793C49.8582 29.6793 55.1655 33.2626 55.3443 33.6042C55.5232 33.9458 56.6397 37.2563 56.6397 37.2563L55.8969 38.5379C55.8969 38.5379 56.0619 38.5883 56.282 38.6365C56.5021 39.5329 57.5934 43.3386 60.0831 42.3321C62.8984 41.1904 64.407 34.1819 62.1533 29.8765ZM59.9203 38.0335C59.2624 38.7763 58.7672 37.5039 58.5287 36.658C59.0698 35.7065 59.7278 34.5235 60.3513 33.3704C60.6631 34.8262 60.8901 36.9376 59.9203 38.0335Z",
    fill: "url(#paint25_linear_675_3719)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M23.3674 16.584L24.1767 16.5726C24.1767 16.5726 26.5518 9.96759 31.9807 8.95427C31.9807 8.95427 32.3429 16.3869 39.3926 16.5771C47.9463 16.8087 51.94 13.0144 54.3862 8.78691C54.3862 8.78691 63.5084 6.04267 63.1737 16.231L64.4621 16.208L64.9826 22.7213L64.4002 23.7254L65.7116 23.7025C65.7116 23.7025 70.5971 13.9705 71.6105 10.5018C72.2799 8.21376 72.9424 1.58358 72.5894 1.01501C73.0639 1.95269 65.9661 14.5436 65.3654 14.5551C64.7647 14.5665 63.3044 14.6353 63.3044 14.6353C62.5272 4.83906 54.1455 7.23253 54.1455 7.23253C50.984 13.1337 44.8559 16.0888 38.4252 15.2062C31.9944 14.3235 31.9279 7.62685 31.9279 7.62685C25.1373 10.0685 23.67 15.9558 23.67 15.9558L22.5054 15.9765L22.8493 17.5652L23.3674 16.584Z",
    fill: "#C40040"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M43.7254 53.9969C43.04 54.1527 36.4442 53.9258 35.6716 53.9395C34.8989 53.9533 34.6995 54.0152 34.1447 53.2495C33.5899 52.486 32.8883 53.6736 32.2854 53.6828C31.6847 53.6942 16.5719 53.1876 15.6572 53.2334C14.7402 53.2793 14.1143 53.4329 13.4104 52.5273C12.7066 51.6217 12.1587 53.0087 11.3563 53.0798C10.5562 53.1509 0.505452 53.4008 0.675104 52.9308C0.555889 53.1738 0.491694 53.3389 0.500864 53.4008C0.597153 54.045 2.20425 57.2821 2.8072 57.4426C3.41244 57.6031 12.7296 57.8668 12.7296 57.8668C12.7685 56.5852 14.2908 57.8415 14.6806 57.9195C15.068 57.9974 31.201 58.6577 31.201 58.6577C32.3267 56.7044 33.3514 58.7196 33.6541 58.8434C33.9567 58.9672 44.028 59.7192 44.8809 59.3615C45.7337 59.0016 49.0259 51.3191 49.7618 48.4144C50.1493 46.8829 50.5963 42.1533 50.5963 42.1533C50.5963 42.1533 44.4109 53.841 43.7254 53.9969Z",
    fill: "#C40040"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M28.4246 40.6287C32.8859 41.0276 35.6393 44.1112 35.7402 49.7533C35.7402 49.7533 36.0039 50.0054 36.9507 50.1338C36.9507 50.1338 37.462 40.9268 28.4246 40.6287Z",
    fill: "#C40040"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M15.1185 49.0471C9.24255 48.9233 9.58873 42.4559 9.58873 42.4559L9.33655 41.1698C9.33655 41.1675 7.77758 48.8477 15.1185 49.0471Z",
    fill: "#C40040"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M62.8916 37.8707L61.5412 37.7469C62.7265 36.7153 62.1304 33.3658 61.9286 32.4969C61.7292 31.6395 62.1487 30.2295 62.6164 30.9654C62.4835 30.5895 62.3345 30.2226 62.1533 29.8765C62.362 29.4294 62.2542 29.0328 62.2657 28.9113C62.3253 28.2648 61.5733 25.1514 60.4178 24.1312C60.7847 24.9199 56.4081 32.4235 55.4429 31.8045C53.845 30.6835 49.6403 28.0561 49.606 27.6343C49.6128 28.0538 49.8559 29.6174 49.8582 29.6793C49.8582 29.6793 55.1655 33.2626 55.3443 33.6042C55.5231 33.9458 56.6396 37.2563 56.6396 37.2563L55.8968 38.5379C55.8968 38.5379 56.0619 38.5883 56.282 38.6365C56.5021 39.5329 57.5934 43.3386 60.0831 42.3321C60.4087 42.1991 60.7159 41.9814 61.0025 41.7062C59.8057 42.5224 58.3774 40.2734 57.7791 38.9047C57.0844 37.3182 58.2811 35.679 58.5264 36.6602C59.0675 35.7088 59.7255 34.5258 60.3491 33.3727C60.6655 34.8285 60.8924 36.9399 59.9203 38.0358C59.5902 38.4095 59.3013 38.2742 59.0652 37.9395C59.604 39.2211 62.1923 39.3701 61.9149 40.5026C62.3345 39.7621 62.6623 38.8565 62.8916 37.8707Z",
    fill: "#C40040"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9206 38.0335C59.5904 38.4072 59.3016 38.2719 59.0654 37.9372C59.6042 39.2188 62.1925 39.3678 61.9151 40.5003C62.3347 39.7621 62.6625 38.8543 62.8918 37.8684L61.5414 37.7446C61.7455 37.5681 61.8922 37.3182 62.0023 37.0293L60.4525 36.9973C60.3401 37.3939 60.1727 37.7492 59.9206 38.0335Z",
    fill: "#941946"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M59.84 38.3522C59.3288 38.5677 62.3848 39.7644 62.6393 38.8176C62.8915 37.8707 60.835 37.9326 59.84 38.3522Z",
    fill: "#B21946"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M61.9287 32.4969C61.8645 32.2218 61.8645 31.8894 61.9104 31.589C61.9608 30.578 62.2634 30.1768 62.2841 30.1539C62.2405 30.0622 62.2015 29.9682 62.1557 29.8765C61.5435 30.8806 57.7998 36.3828 57.5957 36.0825C57.3894 35.7822 56.6214 32.8202 56.0092 32.231C55.3971 31.6418 49.6519 28.1272 49.6083 27.6343C49.6106 27.7719 49.6381 28.0378 49.6748 28.329C49.6748 28.329 48.7486 28.3817 48.7624 28.4963C48.7624 28.4963 48.9205 30.2181 48.9228 30.2502C48.9228 30.2502 54.1729 34.0742 54.3517 34.4158C54.5305 34.7574 55.7387 37.763 55.7387 37.763L55.8969 38.5333C55.8969 38.5333 56.062 38.5837 56.282 38.6319C56.4288 39.2325 56.9698 41.1285 58.0542 42.0203C59.0171 42.1969 58.2147 40.4637 57.6164 38.9597C57.0157 37.4535 57.5888 36.6121 58.5082 35.5644C59.4275 34.5167 60.3491 33.3681 60.3491 33.3681C60.5669 34.3722 60.732 35.679 60.5027 36.7588C61.2341 36.9537 62.08 34.1522 61.9287 32.4969Z",
    fill: "#B21946"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7717 37.6873C69.1917 37.238 68.4191 37.3962 68.0523 37.7171C67.9514 37.8065 67.3072 38.829 66.4245 40.2734C66.1609 39.6177 65.8858 39.0308 65.6611 38.5677C64.1663 35.514 59.6614 35.1013 59.0722 37.8341C58.9392 38.4508 60.5027 38.4531 61.3579 38.2674C62.2153 38.0794 64.0379 39.0789 64.4598 43.4991C64.4598 43.5059 64.4621 43.5128 64.4621 43.5197C62.3804 46.9838 60.1428 50.762 59.9984 51.044C59.7325 51.5644 59.6614 52.541 59.6614 52.541C59.6614 52.541 60.7802 52.5342 60.9223 52.5158C61.0645 52.4975 61.2433 58.2679 61.2272 58.4422C61.2112 58.6164 60.5394 59.8728 60.5394 59.8728C60.5394 59.8728 61.4611 60.3588 62.1076 59.6298C62.7541 58.9007 70.1844 44.9044 70.393 43.6664C70.6016 42.4307 70.3517 38.1344 69.7717 37.6873Z",
    fill: "url(#paint26_linear_675_3719)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M56.6373 37.254C56.6373 37.254 59.3747 34.817 62.1533 29.8765C62.1533 29.8765 61.0116 33.0586 59.0675 34.8055C57.277 36.4126 56.3554 38.8818 56.5365 39.5054L56.2797 38.6365L55.8945 38.5379L56.6373 37.254Z",
    fill: "#B21946"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M38.3928 51.9358L44.1679 49.8931L42.9436 52.1238L38.3928 51.9358Z",
    fill: "#B21946"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M6.34943 46.9632L4.3457 50.5625L10.1368 50.6107L6.34943 46.9632Z",
    fill: "#B21946"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M28.1084 7.27607L28.8993 5.00182L32.8357 4.77944L28.1084 7.27607Z",
    fill: "#B21946"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M61.6948 4.07561L67.8229 3.85094L65.7687 7.50304L61.6948 4.07561Z",
    fill: "#B21946"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M66.2089 13.5096C65.7779 14.1561 65.4707 14.5528 65.363 14.5551C64.7623 14.5665 63.3019 14.6353 63.3019 14.6353C62.5247 4.83904 54.143 7.23251 54.143 7.23251C50.9815 13.1336 44.8534 16.0888 38.4227 15.2061C31.992 14.3235 31.9255 7.62683 31.9255 7.62683C25.1348 10.0684 23.6676 15.9558 23.6676 15.9558L22.5029 15.9765L22.8468 17.5652L22.6382 17.8931L24.5181 17.8587C24.5181 17.8587 26.6846 11.0267 31.8544 10.0478C31.8544 10.0478 32.047 17.2534 39.4337 17.8954C46.8205 18.5373 51.6326 16.0246 54.6222 9.98591C54.6222 9.98591 61.8438 7.59474 62.2794 17.1892L63.9347 17.1594L64.2923 24.0624L64.4024 23.7254L65.7137 23.7025C65.7137 23.7025 65.4547 15.5271 65.5601 15.0388C65.6633 14.5482 66.2089 13.5096 66.2089 13.5096C66.2066 13.5096 66.2066 13.5096 66.2089 13.5096Z",
    fill: "#B21946"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M65.7691 7.50304L67.0506 5.2265L63.144 5.29527L65.7691 7.50304Z",
    fill: "#B21946"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M42.9439 52.1238L43.6316 50.8697L40.7246 52.0321L42.9439 52.1238Z",
    fill: "#B21946"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M10.1368 50.6107L5.67773 50.574L6.85154 48.0751L10.1368 50.6107Z",
    fill: "#B21946"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M29.1904 6.70523L29.4999 5.73317L31.2515 5.61625L29.1904 6.70523Z",
    fill: "#B21946"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M44.9038 59.0199C44.7021 58.9099 43.9249 53.8272 44.2321 53.4237C43.9914 53.7699 43.8126 53.9785 43.7254 53.9969C43.04 54.1528 36.4442 53.9258 35.6716 53.9395C34.8989 53.9533 34.6995 54.0152 34.1447 53.2495C33.5899 52.486 32.8883 53.6736 32.2854 53.6828C31.6847 53.6942 16.5719 53.1876 15.6572 53.2334C14.7402 53.2793 14.1143 53.4329 13.4104 52.5273C12.7066 51.6217 12.1587 53.0087 11.3563 53.0798C10.5562 53.1509 0.505452 53.4008 0.675104 52.9308C0.555889 53.1738 0.491694 53.3389 0.500864 53.4008C0.597153 54.045 2.20425 57.2821 2.8072 57.4426C3.41244 57.6031 12.7296 57.8668 12.7296 57.8668C12.7685 56.5852 14.2908 57.8415 14.6806 57.9195C15.068 57.9974 31.201 58.6577 31.201 58.6577C32.3267 56.7044 33.3514 58.7196 33.6541 58.8434C33.9567 58.9672 44.028 59.7192 44.8809 59.3615C45.0047 59.3088 45.1789 59.1002 45.3899 58.7792C45.2386 58.9236 45.0253 59.0864 44.9038 59.0199Z",
    fill: "#B21946"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4684 27.6228L17.9269 26.7608C17.9269 26.7608 20.9738 26.6851 21.6317 26.6943C22.292 26.7035 26.664 22.8726 26.664 22.8726L26.8084 21.3503C26.8084 21.3503 25.6346 18.1338 25.1646 17.5835C24.8047 17.164 23.0348 17.0127 22.1201 17.1388C21.2053 17.2649 16.9044 25.2087 16.6018 25.9011C16.2992 26.5934 17.4684 27.6228 17.4684 27.6228Z",
    fill: "url(#paint27_linear_675_3719)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M17.4684 27.6228L17.9269 26.7608C17.9269 26.7608 20.9738 26.6852 21.6317 26.6943C22.292 26.7035 26.664 22.8726 26.664 22.8726L26.8084 21.3503C26.8084 21.3503 22.0398 25.5389 21.4667 25.571C17.3515 25.8025 17.0397 24.9749 16.6018 25.9011C16.2992 26.5957 17.4684 27.6228 17.4684 27.6228Z",
    fill: "#C40040"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M21.9185 25.344C21.6961 25.4792 21.7672 26.339 21.813 26.4398C21.8589 26.5384 26.6642 22.8726 26.6642 22.8726C26.6642 22.8726 25.7999 24.2642 25.1258 25.0345C24.4518 25.8048 22.2166 27.4188 21.3179 27.7076C20.4215 27.9988 17.2668 27.9965 17.2668 27.9965L17.4663 27.6228C17.4663 27.6228 16.2512 26.5934 16.5997 25.9011C16.9504 25.211 17.3104 25.4586 18.1105 25.5205C18.9106 25.5824 21.2789 25.5893 21.4646 25.5709C21.6548 25.5549 21.9185 25.344 21.9185 25.344Z",
    fill: "#B21946"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4689 25.5709C22.042 25.5388 26.8106 21.3503 26.8106 21.3503C26.8106 21.3503 25.6368 18.1338 25.1668 17.5835C24.8069 17.164 23.037 17.0127 22.1223 17.1388C21.2075 17.2649 16.9066 25.2064 16.604 25.9011C17.0419 24.9749 17.3537 25.8025 21.4689 25.5709ZM18.9264 22.1275C19.1694 21.2746 21.031 17.9916 22.1131 17.556C23.5781 16.9645 24.8803 17.6592 25.3824 18.3951C26.1985 19.5964 26.0564 20.7909 24.6029 22.9092C23.1494 25.0276 20.4074 25.4471 19.2886 25.4838C18.1721 25.5205 18.3968 23.9799 18.9264 22.1275Z",
    fill: "#FFFF00"
  }))), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M21.0587 21.4741C24.8255 22.1229 26.6916 21.1646 25.9305 19.3741C25.1671 17.5836 24.5572 17.1136 22.7002 17.3428C20.8386 17.5721 19.2361 21.16 21.0587 21.4741Z",
    fill: "#FFF700"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9192 18.2461C24.9399 19.624 25.513 19.3511 25.5932 19.2778C25.8592 19.0348 25.4901 18.12 25.1829 17.7968C24.878 17.4735 24.9147 17.8357 24.9192 18.2461Z",
    fill: "#FFFFE0"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9304 20.2109C26.2881 20.2567 26.0267 19.2686 25.6851 19.5552C25.2954 19.8853 25.5728 20.165 25.9304 20.2109Z",
    fill: "#FFFFE0"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4428 31.8023C56.408 32.4213 60.7845 24.9176 60.4177 24.1289C60.1907 23.9272 59.9569 23.8034 59.723 23.8057C58.3039 23.8286 49.5966 27.2125 49.6035 27.632C49.6402 28.0539 53.8448 30.6812 55.4428 31.8023ZM57.137 24.6081C59.3471 23.9455 59.5672 26.4834 58.8794 27.5931C58.1893 28.7004 55.9082 31.9261 52.5197 29.6105C48.7782 27.0543 54.9269 25.2707 57.137 24.6081Z",
    fill: "#FFFF00"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M54.0606 26.8319C56.0483 30.0966 58.9118 28.3702 59.689 26.5866C60.4639 24.803 60.4707 23.6956 58.6573 24.161C56.7957 24.6379 53.3752 25.7062 54.0606 26.8319Z",
    fill: "#FFF700"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8151 25.0781C58.8293 26.0387 58.7468 27.3569 58.96 27.6504C59.1732 27.9415 60.2988 25.4082 60.3218 24.9612C60.347 24.5164 60.1086 24.7938 59.8151 25.0781Z",
    fill: "#FFFFE0"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M60.9223 52.5158C61.0645 52.4975 61.2433 58.2679 61.2272 58.4422C61.2112 58.6164 60.5394 59.8728 60.5394 59.8728C60.5394 59.8728 61.4611 60.3588 62.1076 59.6297C62.7541 58.9007 69.4095 44.8196 69.6181 43.5816C69.8244 42.3436 70.3517 38.1344 69.7717 37.685C70.2715 38.3636 67.4768 42.4536 67.1765 41.6856C66.8762 40.9176 66.4245 40.2711 66.4245 40.2711C66.4245 40.2711 66.9106 41.1744 67.3828 43.5747C67.8551 45.9728 66.3787 46.8027 65.8261 46.296C65.2736 45.7894 65.3585 42.5499 65.1177 40.2825C64.877 38.0152 62.7587 36.4929 61.1905 36.807C60.191 37.0064 59.666 36.9193 59.6797 36.7221C59.3886 37.0064 59.1708 37.371 59.0722 37.8341C58.9392 38.4508 60.5027 38.4531 61.3579 38.2674C62.2153 38.0794 64.0379 39.0789 64.4598 43.4991C64.4598 43.5059 64.4621 43.5128 64.4621 43.5197C64.2191 43.9255 63.9715 44.3359 63.7284 44.7439C64.43 43.5701 65.3241 45.3331 65.1888 45.7366C65.0536 46.1401 62.4148 50.9156 61.9287 50.9248C61.4427 50.9339 60.4363 50.2874 60.0007 51.044C59.7347 51.5644 59.6637 52.541 59.6637 52.541C59.6637 52.541 60.7779 52.5365 60.9223 52.5158Z",
    fill: "#C40040"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M61.5231 50.8514C61.0072 50.7093 60.3332 50.4594 59.9962 51.044C59.7302 51.5644 59.6592 52.5411 59.6592 52.5411C59.6592 52.5411 60.778 52.5342 60.9201 52.5158C61.0622 52.4975 61.2411 58.2679 61.225 58.4422C61.209 58.6164 60.5372 59.8728 60.5372 59.8728C60.5372 59.8728 61.4588 60.3588 62.1054 59.6298C62.1329 59.6 62.1741 59.538 62.2246 59.4647C62.8459 58.5545 62.596 51.2687 61.5231 50.8514Z",
    fill: "#B21946"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M61.3556 38.2674C62.213 38.0794 64.0357 39.0789 64.4575 43.4991C64.4575 43.5059 64.4598 43.5128 64.4598 43.5197C64.2168 43.9255 63.9692 44.3359 63.7262 44.7439C64.4277 43.5701 65.3218 45.3331 65.1866 45.7366C65.2347 47.2773 65.1751 49.8931 66.6744 48.49C68.1761 47.087 67.4929 42.5431 67.1765 41.6902C66.8762 40.9222 66.4246 40.2757 66.4246 40.2757C66.4246 40.2757 66.9106 41.179 67.3829 43.5793C67.4333 43.8315 67.4562 44.063 67.4654 44.2808C67.4677 44.2854 67.6167 45.8742 67.0688 46.5941C66.5231 47.3139 65.5304 47.0939 65.4915 46.0851C65.4525 45.0764 64.5767 44.1662 64.6753 43.6504C64.7739 43.1323 65.4273 41.2523 64.7922 39.3609C64.1549 37.4718 62.4813 37.4787 61.2089 37.8432C59.9778 38.1986 59.6981 36.8276 59.4459 37.0041C59.274 37.238 59.1433 37.5131 59.0722 37.8387C58.9369 38.4508 60.5005 38.4531 61.3556 38.2674Z",
    fill: "url(#paint28_linear_675_3719)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5322 36.0114C62.894 36.0321 64.6685 36.6648 65.0926 37.9945C65.5167 39.3242 64.0266 37.0248 62.2062 36.8368C60.3836 36.6488 59.1594 37.0225 59.9159 36.5112C60.6725 36 61.5322 36.0114 61.5322 36.0114Z",
    fill: "#FFFF00"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.44
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.9747 41.9905C67.7771 44.7439 67.5433 44.87 66.4107 43.7398C65.2782 42.6095 65.8261 38.7144 66.3465 40.0877C66.8669 41.4586 66.9747 41.9905 66.9747 41.9905Z",
    fill: "#FFFF00"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.44
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.3685 37.7974C68.8499 37.6552 69.4575 37.8364 69.0815 39.2784C68.7055 40.7227 67.1763 41.6856 66.8462 40.9749C66.9585 41.1858 67.0754 41.4266 67.1763 41.6856C67.4766 42.4536 70.269 38.3636 69.7715 37.685C69.1915 37.2357 68.4189 37.3939 68.0521 37.7148C67.9741 37.7836 67.5844 38.3912 67.0135 39.3128C67.0204 39.3059 67.8893 37.9395 68.3685 37.7974Z",
    fill: "#FFFF00"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.44
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.9242 50.9225C62.2268 50.9179 63.357 49.0746 64.2053 47.5822C63.2676 49.1686 61.8737 50.3149 61.1974 50.2278C60.5188 50.1407 62.1901 47.3162 62.1901 47.3162C61.0048 49.3085 60.0878 50.8675 59.9961 51.044C60.434 50.2851 61.4381 50.9316 61.9242 50.9225Z",
    fill: "#FFFF00"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.44
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.1271 40.067C60.4866 40.5026 62.0731 40.0258 61.0047 39.4228C59.9341 38.8199 59.1408 38.5998 58.7855 37.4099C58.4301 36.2224 58.3316 36.2109 57.9281 36.6075C57.5246 37.0041 57.8478 39.6567 59.1271 40.067Z",
    fill: "#FFFF00"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.44
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.3415 33.5309C63.066 34.7551 63.0729 36.376 63.2242 35.2136C63.3755 34.0513 63.0889 32.1897 62.7129 31.2245C62.3369 30.2616 62.0183 31.0411 61.9632 31.3139C61.9082 31.589 61.8395 32.6803 62.3415 33.5309Z",
    fill: "#FFFF00"
  }))), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M33.6519 58.848C33.9133 58.9259 34.9266 54.3843 34.6194 53.7745C34.3122 53.1623 33.182 52.8964 32.8404 53.5911C32.4988 54.2857 31.2012 58.6646 31.2012 58.6646C31.2012 58.6646 31.7583 57.8026 32.3566 57.9424C32.9504 58.0777 33.4273 58.7792 33.6519 58.848Z",
    fill: "#B21946"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M14.6784 57.9241C15.1392 57.9585 14.1694 53.4833 13.7797 52.9216C13.3899 52.3599 12.4568 52.2866 11.6659 52.9904C10.8772 53.6942 12.7274 57.8713 12.7274 57.8713C12.7274 57.8713 12.6815 57.3349 13.101 57.3028C13.5206 57.2707 14.2359 57.8897 14.6784 57.9241Z",
    fill: "#B21946"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M34.6927 2.90639C34.6927 2.90639 34.0347 4.51121 35.2933 4.42868C36.5519 4.34614 36.8568 2.87888 36.8568 2.87888C36.8568 2.87888 36.3181 3.7088 35.8023 3.70192C35.2864 3.69734 35.1649 3.13107 35.0136 2.99581C34.8623 2.86054 34.6927 2.90639 34.6927 2.90639Z",
    fill: "#B21946"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M54.2647 1.93662L53.7122 1.9412C53.7122 1.9412 53.9093 3.33739 54.7484 3.4589C55.5898 3.58041 55.9291 2.55562 56.0758 2.30343C56.2226 2.04896 56.4404 1.89306 56.4404 1.89306C56.4404 1.89306 56.1904 1.8495 56.03 2.10398C55.8695 2.35846 55.6081 3.03706 55.1358 2.95912C54.8607 2.91097 54.2647 1.93662 54.2647 1.93662Z",
    fill: "#B21946"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M38.9434 66.3471L46.901 66.6795L50.0441 62.0645L46.8918 65.8633L38.9434 66.3471Z",
    fill: "#B53356"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M53.627 65.7212C50.759 70.8222 49.913 71.698 53.4757 68.9675C57.0384 66.2393 57.7652 65.3452 58.3016 62.037C58.8381 58.7288 60.1288 54.1573 57.9142 58.0937C55.7018 62.0324 53.627 65.7212 53.627 65.7212Z",
    fill: "#B53356"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M74.1047 29.3125C76.8787 24.3788 76.4867 26.2519 75.6544 30.0599C74.8222 33.8679 73.6805 35.0486 72.1468 35.8235C70.6131 36.5984 69.2558 37.9372 71.0028 34.8285C72.7498 31.7197 74.1047 29.3125 74.1047 29.3125Z",
    fill: "#B53356"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M54.0308 65.0059C52.3205 68.016 52.1164 64.9967 53.6846 61.4019C55.255 57.8071 61.3739 52.0573 59.1478 55.9066C56.924 59.7512 54.0308 65.0059 54.0308 65.0059Z",
    fill: "#B21946"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M42.4483 71.8401C48.8584 72.5095 50.3647 71.9479 46.5452 70.2949C42.7257 68.6442 37.8425 69.6759 35.3986 70.0198C32.9547 70.3637 31.6594 70.7122 35.417 71.1042C39.1745 71.4985 42.4483 71.8401 42.4483 71.8401Z",
    fill: "#B21946"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.56
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9253 7.62455C31.9253 7.62455 31.9895 14.3212 38.4226 15.2039C44.8533 16.0865 50.9814 13.1314 54.1429 7.23023C54.1429 7.23023 62.5246 4.83676 63.3018 14.633C63.3018 14.633 64.7622 14.5642 65.3628 14.5528C65.9635 14.5413 73.0636 1.95038 72.5868 1.01271C72.2452 0.467076 57.8729 1.78532 56.4378 1.89078C56.4378 1.89078 56.22 2.04667 56.0732 2.30115C55.9265 2.55563 55.5872 3.57813 54.7458 3.45662C53.9044 3.33511 53.7096 1.93892 53.7096 1.93892C51.096 1.96414 39.8738 2.11774 36.8544 2.87888C36.8544 2.87888 36.5518 4.34614 35.2909 4.42868C34.0391 4.51121 34.681 2.92703 34.6879 2.90869C33.7823 2.85596 28.2068 3.34887 28.2068 3.34887L22.5005 15.9742L23.6651 15.9535C23.6674 15.9513 25.1347 10.0662 31.9253 7.62455ZM25.1186 11.0978C26.3131 6.13437 29.6992 3.78446 30.7928 3.41764C31.8864 3.05083 33.3995 3.36262 34.1515 4.56394C34.9034 5.76526 36.9736 3.50247 38.3813 2.98434C39.7889 2.46622 48.2486 2.00311 50.5756 2.3493C52.9026 2.69548 53.611 5.10041 57.3686 3.09439C61.1261 1.08837 64.0767 1.37953 64.0767 1.37953C70.0443 0.909547 71.2066 3.75466 70.097 6.29943C68.9874 8.84421 65.1152 14.9723 63.029 11.3202C60.9427 7.66811 59.049 6.03579 56.8848 5.85238C54.7183 5.67126 52.5243 5.3824 53.1823 6.17793C53.8403 6.97575 53.423 8.68832 51.527 10.4055C49.631 12.1226 37.65 18.1957 34.1813 12.5766C30.7126 6.95741 33.6517 4.36449 29.713 7.01472C25.772 9.66726 23.9242 16.0613 25.1186 11.0978Z",
    fill: "#FFFF00"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.56
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.951 50.1338C36.0042 50.0077 35.7405 49.7532 35.7405 49.7532C35.6397 44.1089 32.884 41.0276 28.4249 40.6287C19.3875 40.3307 15.121 49.0448 15.121 49.0448C7.77778 48.8454 9.33904 41.1652 9.33904 41.1652L8.00703 41.1881C8.00703 41.1881 1.18427 51.5713 0.551514 53.2059C0.581317 53.1302 0.6203 53.0408 0.675323 52.9285C0.505671 53.3985 10.5564 53.1486 11.3565 53.0775C12.1566 53.0064 12.7068 51.6217 13.4107 52.525C14.1145 53.4306 14.7427 53.2747 15.6574 53.2311C16.5745 53.1853 31.6849 53.6919 32.2856 53.6805C32.8863 53.669 33.5901 52.4814 34.1449 53.2472C34.6997 54.0106 34.8992 53.951 35.6718 53.9372C36.4444 53.9235 43.0402 54.1504 43.7257 53.9945C44.4111 53.8386 50.5943 42.151 50.5943 42.151L48.8473 42.2404C44.1291 50.8674 36.951 50.1338 36.951 50.1338ZM47.5336 47.3277C46.1031 50.3539 44.3538 53.5865 41.3345 53.9258C38.3151 54.2651 34.2893 52.3989 33.5465 52.2911C32.8037 52.1857 32.2168 53.4535 24.1652 53.3434C16.1136 53.2334 14.1099 51.6859 12.3905 51.7318C10.671 51.7753 9.09601 53.4008 5.27884 53.0706C1.46167 52.7405 2.38789 50.0444 3.31181 48.7606C4.23572 47.4767 7.88782 41.1721 8.97909 44.102C10.0727 47.0296 10.9072 48.9692 14.1053 49.8266C17.3012 50.684 13.7477 49.9 17.6818 45.8558C21.6159 41.8117 28.4684 39.7942 32.2925 42.6875C36.1142 45.5807 35.7382 49.469 35.3187 50.1636C34.9014 50.8583 36.0913 51.7272 39.4224 50.4639C42.7536 49.2007 44.7275 47.4698 44.7275 47.4698C47.4947 45.1887 48.9642 44.3015 47.5336 47.3277Z",
    fill: "#FFFF00"
  }))), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M45.369 9.96302C43.7871 12.4367 41.0727 13.7389 39.3051 12.8769C37.5398 12.0126 37.3908 9.30734 38.9727 6.83592C40.5545 4.36221 42.7738 2.68862 44.5208 3.58732C46.7216 4.71756 46.9532 7.48931 45.369 9.96302Z",
    fill: "url(#paint29_linear_675_3719)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M45.369 9.96302C43.7871 12.4367 41.0727 13.7389 39.3051 12.8769C37.5398 12.0126 37.3908 9.30734 38.9727 6.83592C40.5545 4.36221 42.7738 2.68862 44.5208 3.58732C46.7216 4.71756 46.9532 7.48931 45.369 9.96302Z",
    fill: "#C54200"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9681 9.23398C43.5353 11.5036 41.0134 12.6545 39.3353 11.804C37.6571 10.9534 37.4576 8.42698 38.8882 6.15731C40.3211 3.88765 42.8429 2.73677 44.5211 3.58732C46.2016 4.43558 46.401 6.96431 44.9681 9.23398Z",
    fill: "url(#paint30_linear_675_3719)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M44.1932 10.2954C45.3945 9.39903 45.6673 9.60078 45.0873 10.6691C44.505 11.7375 41.8846 14.6514 39.3719 14.3464C36.8569 14.0438 37.657 9.88735 37.9482 9.4082C38.2393 8.92905 38.3333 11.6343 40.9492 11.5885C42.8543 11.5541 43.7278 10.6439 44.1932 10.2954Z",
    fill: "#A40040"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3669 6.34073C45.4059 5.6071 45.1331 4.88952 44.6218 4.35076C44.3077 4.02063 43.8951 3.80512 43.4343 3.75927C42.006 3.61713 40.2636 4.6167 39.193 6.31322C38.4272 7.526 38.1796 8.82132 38.4181 9.83464C38.6152 10.6737 39.2503 11.2859 40.0641 11.3982C43.2669 11.8292 45.2614 8.30778 45.3669 6.34073Z",
    fill: "#480030"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2088 6.39574C45.2569 5.48787 44.803 4.60293 44.0052 4.0848C42.5631 3.49561 40.4998 4.48142 39.3099 6.36823C38.2278 8.08309 38.2278 9.97219 39.2205 10.903C39.5392 11.0818 39.8647 11.1896 40.1513 11.2285C43.205 11.6412 45.1102 8.27796 45.2088 6.39574Z",
    fill: "url(#paint31_linear_675_3719)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1514 11.2308C43.2051 11.6411 45.1103 8.27791 45.2088 6.39798C45.3074 4.51805 42.9712 2.50745 40.1468 3.87842C37.3223 5.24939 37.4003 8.33064 37.9803 9.58469C38.4503 10.598 39.4269 11.1322 40.1514 11.2308Z",
    fill: "url(#paint32_linear_675_3719)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M45.2088 6.39574C45.2569 5.48787 44.803 4.60293 44.0052 4.0848C42.5631 3.49561 40.4998 4.48142 39.3099 6.36823C38.2278 8.08309 38.2278 9.97219 39.2205 10.903C39.5392 11.0818 39.8647 11.1896 40.1513 11.2285C43.205 11.6412 45.1102 8.27796 45.2088 6.39574Z",
    fill: "url(#paint33_linear_675_3719)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M44.553 4.94682C43.8951 3.43829 41.2288 2.8491 39.7065 4.49976C38.1819 6.15043 42.3109 7.80798 43.3861 7.80798C44.4613 7.80798 45.0437 6.07248 44.553 4.94682Z",
    fill: "url(#paint34_linear_675_3719)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M40.1512 11.2308C43.205 11.6412 45.1101 8.27798 45.2087 6.39805C45.2637 5.36409 44.5805 4.29345 43.487 3.76386C44.553 4.32784 45.6626 6.00831 43.7965 8.33758C41.8822 10.7265 38.253 10.6875 37.7349 8.78235C37.7922 9.09185 37.877 9.36696 37.9779 9.58476C38.4501 10.5981 39.4268 11.1323 40.1512 11.2308Z",
    fill: "#BD2892"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1407 4.44704C43.7693 3.9633 42.3754 3.6561 42.6 4.24529C42.8247 4.83449 43.7211 5.58417 44.0489 5.56353C44.3768 5.54519 44.4823 4.8918 44.1407 4.44704Z",
    fill: "#E7D1F4"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1016 6.26278C44.2185 5.81801 43.7188 5.50393 43.4414 5.61397C43.1639 5.72402 44.0099 6.60896 44.1016 6.26278Z",
    fill: "#E7D1F4"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M41.8134 10.0799C41.3022 10.8892 40.0596 11.0199 39.0394 10.3711C38.0169 9.72229 37.6019 8.5416 38.1132 7.73231C38.6244 6.92303 39.867 6.79235 40.8872 7.44115C41.9097 8.08996 42.3247 9.27064 41.8134 10.0799Z",
    fill: "url(#paint35_linear_675_3719)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M40.4538 10.7815C41.435 10.5774 43.1591 9.71311 43.6038 9.35776C44.0486 9.00241 42.861 10.5774 42.0884 10.8571C40.9971 11.2491 39.7844 10.9213 40.4538 10.7815Z",
    fill: "#AB2892"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M38.0606 9.13769C37.4943 8.36509 37.9505 6.28112 38.2348 6.0725C38.5191 5.86158 38.5672 7.25318 39.3582 8.53245C40.1491 9.81172 39.1152 10.5774 38.0606 9.13769Z",
    fill: "#B1BDDE"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M43.3634 5.09814C43.8655 6.36824 43.5582 7.97306 43.3336 8.50494C43.1089 9.03911 43.9251 8.21607 44.4386 7.0606C44.9522 5.90284 44.5899 4.78177 44.0649 4.50207C43.5376 4.21779 42.9461 4.04126 43.3634 5.09814Z",
    fill: "#B1BDDE"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M38.7759 6.35447C38.5008 5.70796 38.9456 4.73131 39.4453 4.49976C39.9474 4.26821 39.6677 5.39616 39.5027 5.74693C39.3399 6.0954 38.9478 6.76026 38.7759 6.35447Z",
    fill: "#B1BDDE"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7849 9.95157C38.3424 9.61456 39.961 10.002 40.3691 10.0937C40.7772 10.1854 39.436 10.4468 38.7849 9.95157Z",
    fill: "#E7D1F4"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M38.2047 10.7242C38.6816 11.5426 39.0759 12.4505 40.9604 12.1226C42.845 11.7948 40.4263 13.2437 39.2158 12.7439C38.0053 12.2441 37.9136 10.2244 38.2047 10.7242Z",
    fill: "#9A0040"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6841 3.73632C44.8373 4.07792 45.3302 5.30216 45.3989 5.67586C45.4677 6.04955 45.6901 4.08938 44.6928 3.67901C43.6933 3.26863 42.5607 3.4016 43.6841 3.73632Z",
    fill: "#FFEF97"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9181 48.3433C27.3362 50.817 24.6217 52.1215 22.8542 51.2572C21.0889 50.3929 20.9399 47.6876 22.5217 45.2162C24.1036 42.7425 26.3229 41.0689 28.0698 41.9676C30.2707 43.0979 30.4999 45.8719 28.9181 48.3433Z",
    fill: "url(#paint36_linear_675_3719)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9181 48.3433C27.3362 50.817 24.6217 52.1215 22.8542 51.2572C21.0889 50.3929 20.9399 47.6876 22.5217 45.2162C24.1036 42.7425 26.3229 41.0689 28.0698 41.9676C30.2707 43.0979 30.4999 45.8719 28.9181 48.3433Z",
    fill: "#C54200"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5167 47.6143C27.0839 49.8839 24.562 51.0348 22.8838 50.1843C21.2057 49.3337 21.0062 46.8073 22.4368 44.5376C23.8696 42.2679 26.3915 41.1171 28.0697 41.9676C29.7502 42.8182 29.9496 45.3469 28.5167 47.6143Z",
    fill: "url(#paint37_linear_675_3719)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M27.7418 48.6757C28.9431 47.7793 29.2159 47.9811 28.6359 49.0494C28.0536 50.1178 25.4332 53.0317 22.9205 52.7267C20.4055 52.4241 21.2056 48.2676 21.4968 47.7885C21.7879 47.3093 21.8819 50.0146 24.4978 49.9687C26.4029 49.9344 27.2741 49.0242 27.7418 48.6757Z",
    fill: "#A40040"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M28.913 44.721C28.952 43.9874 28.6792 43.2698 28.168 42.731C27.8539 42.4009 27.4412 42.1854 26.9804 42.1396C25.5521 41.9974 23.8097 42.997 22.7391 44.6935C21.9734 45.9063 21.7258 47.2016 21.9642 48.2149C22.1637 49.054 22.7964 49.6661 23.6103 49.7785C26.8153 50.2118 28.8099 46.6904 28.913 44.721Z",
    fill: "#480030"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7574 44.7783C28.8055 43.8704 28.3516 42.9855 27.5537 42.4674C26.1117 41.8782 24.0484 42.864 22.8585 44.7508C21.7764 46.4657 21.7764 48.3548 22.7691 49.2855C23.0878 49.4644 23.4133 49.5721 23.6999 49.6111C26.7536 50.0215 28.6588 46.6582 28.7574 44.7783Z",
    fill: "url(#paint38_linear_675_3719)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6999 49.6111C26.7537 50.0214 28.6588 46.6582 28.7574 44.7783C28.856 42.8983 26.5199 40.8877 23.6954 42.2587C20.8709 43.632 20.9488 46.7109 21.5289 47.965C21.9988 48.9783 22.9755 49.5125 23.6999 49.6111Z",
    fill: "url(#paint39_linear_675_3719)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M28.7574 44.7783C28.8055 43.8704 28.3516 42.9855 27.5537 42.4674C26.1117 41.8782 24.0484 42.864 22.8585 44.7508C21.7764 46.4657 21.7764 48.3548 22.7691 49.2855C23.0878 49.4644 23.4133 49.5721 23.6999 49.6111C26.7536 50.0215 28.6588 46.6582 28.7574 44.7783Z",
    fill: "url(#paint40_linear_675_3719)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M23.6998 49.6111C26.7536 50.0215 28.6587 46.6582 28.7573 44.7783C28.8123 43.7444 28.1291 42.6737 27.0356 42.1441C28.1016 42.7081 29.2112 44.3886 27.3451 46.7179C25.4307 49.1067 21.8016 49.0678 21.2834 47.1626C21.3408 47.4721 21.4256 47.7472 21.5264 47.965C21.9987 48.9783 22.9754 49.5125 23.6998 49.6111Z",
    fill: "#BD2892"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6889 42.8273C27.3175 42.3436 25.9214 42.0364 26.1483 42.6256C26.3753 43.2148 27.4413 44.6408 27.7669 44.6224C28.0947 44.6041 28.0305 43.2721 27.6889 42.8273Z",
    fill: "#E7D1F4"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M25.362 48.4602C24.8507 49.2695 23.6081 49.4002 22.5879 48.7514C21.5654 48.1026 21.1505 46.9219 21.6618 46.1126C22.173 45.3033 23.4156 45.1727 24.4358 45.8215C25.4583 46.4703 25.8709 47.651 25.362 48.4602Z",
    fill: "url(#paint41_linear_675_3719)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M24.0024 49.1641C24.9836 48.96 26.7076 48.0957 27.1524 47.7404C27.5972 47.385 26.4096 48.96 25.637 49.2397C24.5457 49.6295 23.3329 49.3016 24.0024 49.1641Z",
    fill: "#AB2892"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M21.6089 47.518C21.0426 46.7454 21.4989 44.6614 21.7831 44.4528C22.0674 44.2419 22.1156 45.6335 22.9065 46.9127C23.6975 48.1943 22.6635 48.96 21.6089 47.518Z",
    fill: "#B1BDDE"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7017 43.4532C24.8576 42.8686 24.9814 41.8621 24.2455 42.1694C23.8879 42.3298 23.5509 42.5637 23.2551 42.8823C22.494 43.7054 23.1428 44.533 24.1171 45.152C24.6651 45.3904 24.5458 44.0401 24.7017 43.4532Z",
    fill: "url(#paint42_linear_675_3719)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1018 43.3294C27.7487 42.5155 26.8088 41.9745 25.7794 41.9034C25.0022 41.8897 24.2594 45.2735 24.9564 45.606C25.7404 45.9682 26.5406 46.1906 26.9326 46.1906C28.0101 46.1883 28.5924 44.4551 28.1018 43.3294Z",
    fill: "url(#paint43_linear_675_3719)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M26.9117 43.4784C27.4137 44.7485 27.1065 46.3533 26.8819 46.8852C26.6572 47.4194 27.4734 46.5963 27.9869 45.4409C28.5005 44.2831 28.1382 43.162 27.6132 42.8823C27.0882 42.6026 26.4944 42.4238 26.9117 43.4784Z",
    fill: "#B1BDDE"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M22.3245 44.7348C22.0494 44.0882 22.4941 43.1116 22.9939 42.88C23.496 42.6485 23.2163 43.7765 23.0512 44.1272C22.8885 44.4757 22.4964 45.1428 22.3245 44.7348Z",
    fill: "#B1BDDE"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3335 48.3341C21.891 47.9971 23.5096 48.3846 23.9177 48.4763C24.3258 48.5657 22.9846 48.8271 22.3335 48.3341Z",
    fill: "#E7D1F4"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M21.7535 49.1045C22.2304 49.9229 22.6247 50.8308 24.5092 50.5029C26.3937 50.1751 23.975 51.624 22.7646 51.1242C21.5518 50.6221 21.4624 48.6047 21.7535 49.1045Z",
    fill: "#9A0040"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2327 42.1166C28.3858 42.4582 28.8787 43.6825 28.9475 44.0562C29.0163 44.4299 29.2387 42.4697 28.2414 42.0593C27.2418 41.6489 26.1093 41.7842 27.2327 42.1166Z",
    fill: "#FFEF97"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M29.3989 42.5316C31.9483 45.2323 31.3178 48.4534 31.0381 49.7143C30.7607 50.9752 34.5733 53.2655 35.4216 49.9C36.2698 46.5368 34.1148 43.5449 31.9804 42.2037C29.846 40.8626 27.6841 40.7136 29.3989 42.5316Z",
    fill: "#FFF700"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M7.7526 41.9126C6.18905 44.2441 5.93686 46.6101 8.37159 48.1026C10.8063 49.5951 13.7019 49.6661 11.6546 48.1232C9.60732 46.5803 8.91265 43.9965 8.95392 42.6141C8.99519 41.2317 8.20654 41.234 7.7526 41.9126Z",
    fill: "#FFF700"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M44.1473 48.6666C44.9681 47.1649 47.9393 44.3313 48.7256 43.3959C49.512 42.4605 50.1654 42.1556 49.2575 44.2419C48.3497 46.3281 45.8438 51.3673 45.4197 50.5075C44.9956 49.6478 43.2991 50.2187 44.1473 48.6666Z",
    fill: "#FFF700"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M64.7395 2.8147C69.4714 4.00455 69.2008 3.09898 68.0912 6.03809C66.9839 8.97948 67.5685 10.8617 69.586 7.34257C71.6035 3.82344 72.2248 1.5148 71.4453 1.21676C70.6658 0.918723 58.6228 1.27637 64.7395 2.8147Z",
    fill: "#FFF700"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M46.8776 13.6976C52.4073 11.671 57.1094 4.83218 52.1987 2.95455C47.2856 1.07691 43.8376 2.96372 47.9505 4.66482C52.0634 6.36593 49.0234 10.3367 46.8432 11.7696C44.6629 13.2024 42.8747 15.1626 46.8776 13.6976Z",
    fill: "#FFF700"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M33.2344 11.1804C32.0973 9.22708 31.3499 6.29943 33.3215 5.36406C35.2932 4.42868 34.2408 6.59747 34.4242 8.82817C34.6099 11.0589 35.1671 14.4978 33.2344 11.1804Z",
    fill: "#FFF700"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9471 50.7551C47.4167 48.6551 49.049 45.5326 49.5167 44.2969C49.9844 43.0612 46.7473 46.1539 46.1879 47.3965C45.6262 48.6414 44.8398 52.337 45.9471 50.7551Z",
    fill: "#FFFFE0"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1064 6.40719C69.2123 3.52999 72.7154 2.0398 71.9634 3.36492C71.2091 4.69004 70.2852 6.98493 70.1064 6.40719Z",
    fill: "#FFFFE0"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7977 10.9855C66.8715 11.9644 68.8844 8.10142 68.8683 8.81671C68.8523 9.53429 68.231 10.527 67.7977 10.9855Z",
    fill: "#FFFFE0"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6091 36.6029C64.799 37.2403 60.5417 36.3141 61.2363 36.1421C61.931 35.9679 63.0543 36.3049 63.6091 36.6029Z",
    fill: "#FFFFE0"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M8.37602 43.5334C8.2889 44.909 8.82996 45.716 9.27014 45.3744C9.5292 45.1726 9.03628 43.0359 8.83224 42.6921C8.63279 42.3505 8.40124 43.1254 8.37602 43.5334Z",
    fill: "#FFFFE0"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5163 44.1387C33.2599 42.1625 31.866 41.4907 31.7124 42.3321C31.623 42.825 34.2755 45.3767 34.8349 45.6839C35.3943 45.9911 34.8899 44.7256 34.5163 44.1387Z",
    fill: "#FFFFE0"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2727 11.6091C52.435 10.8686 52.7743 9.96299 52.2402 9.81168C51.9261 9.72227 50.4863 11.3752 50.3281 11.7398C50.1677 12.102 50.9265 11.8292 51.2727 11.6091Z",
    fill: "#FFFFE0"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5193 8.65392C53.3887 8.16789 52.2561 9.0322 52.8086 9.31877C53.4391 9.64661 53.65 9.13995 53.5193 8.65392Z",
    fill: "#FFFFE0"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3801 2.93162C51.3736 1.98936 50.0554 1.96873 49.7734 2.1934C49.4914 2.41808 52.0752 3.42911 52.5199 3.4337C52.9647 3.43599 52.6781 3.21132 52.3801 2.93162Z",
    fill: "#FFFFE0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_675_3719",
    x1: 68.7037,
    y1: -4.5715,
    x2: 25.7779,
    y2: 64.9051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE5E33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6159,
    stopColor: "#962C3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7026,
    stopColor: "#8F263E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A1342"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_675_3719",
    x1: 41.6154,
    y1: 25.2881,
    x2: 20.2775,
    y2: 4.03698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#900040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2016,
    stopColor: "#A9386A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5974,
    stopColor: "#D7A2B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8719,
    stopColor: "#F4E5EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_675_3719",
    x1: 48.6483,
    y1: 46.6489,
    x2: 22.0477,
    y2: 20.1564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#900040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1617,
    stopColor: "#910342"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292,
    stopColor: "#960D4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4115,
    stopColor: "#9D1E57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5245,
    stopColor: "#A83669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6329,
    stopColor: "#B55580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    stopColor: "#C57B9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8403,
    stopColor: "#D9A8BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9379,
    stopColor: "#EFDBE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_675_3719",
    x1: 31.5256,
    y1: 38.6685,
    x2: 15.8417,
    y2: 23.0483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#900040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2016,
    stopColor: "#A9386A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5974,
    stopColor: "#D7A2B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8719,
    stopColor: "#F4E5EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_675_3719",
    x1: 51.1952,
    y1: 23.2367,
    x2: 17.8314,
    y2: -10.6125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#900040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2016,
    stopColor: "#A9386A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5974,
    stopColor: "#D7A2B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8719,
    stopColor: "#F4E5EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_675_3719",
    x1: 45.1828,
    y1: 54.0441,
    x2: 0.769885,
    y2: 9.8117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_675_3719",
    x1: 29.4375,
    y1: 41.0522,
    x2: 20.4211,
    y2: 32.0724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_675_3719",
    x1: 43.1177,
    y1: 58.0477,
    x2: -3.12374,
    y2: 11.9942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_675_3719",
    x1: 58.1905,
    y1: 43.3775,
    x2: 11.8413,
    y2: -2.78336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_675_3719",
    x1: 54.3299,
    y1: 56.8398,
    x2: 22.6102,
    y2: 25.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_675_3719",
    x1: 65.4467,
    y1: 82.5494,
    x2: 31.8999,
    y2: 49.1389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_675_3719",
    x1: 49.3229,
    y1: 66.3842,
    x2: 14.7664,
    y2: 31.9681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_675_3719",
    x1: 37.6895,
    y1: 48.4342,
    x2: 13.8451,
    y2: 24.6867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_675_3719",
    x1: 17.7283,
    y1: 27.8692,
    x2: 10.9889,
    y2: 47.4396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1254,
    stopColor: "#FFDD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3364,
    stopColor: "#FFC300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6069,
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9236,
    stopColor: "#FF5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_675_3719",
    x1: 74.9566,
    y1: 16.8715,
    x2: 21.1445,
    y2: 72.6231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF1D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2128,
    stopColor: "#F1D4C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6714,
    stopColor: "#CC8A92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9493,
    stopColor: "#B55B74"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_675_3719",
    x1: 34.6975,
    y1: 24.1524,
    x2: 34.6262,
    y2: 20.1272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1453,
    stopColor: "#E9C3CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2892,
    stopColor: "#D790A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.423,
    stopColor: "#C86882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5446,
    stopColor: "#BE4B6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6498,
    stopColor: "#B7395B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7269,
    stopColor: "#B53356"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_675_3719",
    x1: 41.1443,
    y1: 25.0105,
    x2: 41.0711,
    y2: 20.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1453,
    stopColor: "#E9C3CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2892,
    stopColor: "#D790A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.423,
    stopColor: "#C86882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5446,
    stopColor: "#BE4B6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6498,
    stopColor: "#B7395B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7269,
    stopColor: "#B53356"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_675_3719",
    x1: 44.3127,
    y1: 34.2151,
    x2: 44.2205,
    y2: 29.0079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1453,
    stopColor: "#E9C3CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2892,
    stopColor: "#D790A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.423,
    stopColor: "#C86882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5446,
    stopColor: "#BE4B6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6498,
    stopColor: "#B7395B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7269,
    stopColor: "#B53356"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_675_3719",
    x1: 27.4468,
    y1: 30.8379,
    x2: 27.3776,
    y2: 26.9283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1453,
    stopColor: "#E9C3CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2892,
    stopColor: "#D790A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.423,
    stopColor: "#C86882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5446,
    stopColor: "#BE4B6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6498,
    stopColor: "#B7395B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7269,
    stopColor: "#B53356"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_675_3719",
    x1: 30.619,
    y1: 34.8648,
    x2: 30.5551,
    y2: 31.2592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1453,
    stopColor: "#E9C3CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2892,
    stopColor: "#D790A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.423,
    stopColor: "#C86882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5446,
    stopColor: "#BE4B6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6498,
    stopColor: "#B7395B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7269,
    stopColor: "#B53356"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_675_3719",
    x1: 36.3408,
    y1: 34.5152,
    x2: 36.2381,
    y2: 28.7123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1453,
    stopColor: "#E9C3CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2892,
    stopColor: "#D790A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.423,
    stopColor: "#C86882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5446,
    stopColor: "#BE4B6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6498,
    stopColor: "#B7395B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7269,
    stopColor: "#B53356"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_675_3719",
    x1: 37.5641,
    y1: 40.5965,
    x2: 37.4725,
    y2: 35.4239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1453,
    stopColor: "#E9C3CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2892,
    stopColor: "#D790A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.423,
    stopColor: "#C86882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5446,
    stopColor: "#BE4B6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6498,
    stopColor: "#B7395B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7269,
    stopColor: "#B53356"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_675_3719",
    x1: 46.266,
    y1: 27.4839,
    x2: 50.0006,
    y2: -10.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0716,
    stopColor: "#FF4F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1426,
    stopColor: "#FF5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4365,
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6877,
    stopColor: "#FFC300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8835,
    stopColor: "#FFDD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_675_3719",
    x1: 22.0884,
    y1: 64.4025,
    x2: 31.336,
    y2: 29.0494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0040099,
    stopColor: "#FF5000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6936,
    stopColor: "#FFBC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_675_3719",
    x1: 58.4067,
    y1: 41.2776,
    x2: 74.1325,
    y2: 49.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2178,
    stopColor: "#FF4F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2776,
    stopColor: "#FF5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5253,
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7369,
    stopColor: "#FFC300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9019,
    stopColor: "#FFDD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_675_3719",
    x1: 53.1322,
    y1: 46.7377,
    x2: 58.8663,
    y2: 21.0272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0613,
    stopColor: "#FF5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2871,
    stopColor: "#FF8E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5011,
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6974,
    stopColor: "#FFD000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8699,
    stopColor: "#FFE100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_675_3719",
    x1: 65.1167,
    y1: 59.9637,
    x2: 64.5187,
    y2: 26.1847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0764,
    stopColor: "#FF5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3931,
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6636,
    stopColor: "#FFC300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8746,
    stopColor: "#FFDD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_675_3719",
    x1: 25.4175,
    y1: 13.3941,
    x2: 18.678,
    y2: 32.9645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1619,
    stopColor: "#FFE700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267,
    stopColor: "#FFDD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4438,
    stopColor: "#FFC300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6706,
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9359,
    stopColor: "#FF5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_675_3719",
    x1: 63.4687,
    y1: 48.9327,
    x2: 63.1758,
    y2: 32.3884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B21946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0918,
    stopColor: "#B5234E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2464,
    stopColor: "#BE3D63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4447,
    stopColor: "#CC6885"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6791,
    stopColor: "#E0A3B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9411,
    stopColor: "#F9EDF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_675_3719",
    x1: 37.929,
    y1: 11.4897,
    x2: 46.378,
    y2: 5.3563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0677,
    stopColor: "#FF2300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2079,
    stopColor: "#FF4B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3527,
    stopColor: "#FF6B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5012,
    stopColor: "#FF8500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6547,
    stopColor: "#FF9700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8164,
    stopColor: "#FFA200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_675_3719",
    x1: 38.0039,
    y1: 11.7637,
    x2: 25.7091,
    y2: 25.6158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1037,
    stopColor: "#FFD100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2518,
    stopColor: "#FFBE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4266,
    stopColor: "#FFA000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6217,
    stopColor: "#FF7500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8311,
    stopColor: "#FF3E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_675_3719",
    x1: 39.8602,
    y1: 6.58209,
    x2: 44.8003,
    y2: 9.70627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#BE0709"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2462,
    stopColor: "#C51C21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4378,
    stopColor: "#D13D48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6611,
    stopColor: "#E26B7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9083,
    stopColor: "#F7A6C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBDDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_675_3719",
    x1: 41.3117,
    y1: 10.0969,
    x2: 41.5697,
    y2: 3.70036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B68BDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.084,
    stopColor: "#B17DDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2567,
    stopColor: "#A765DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3633,
    stopColor: "#A45CDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9403,
    stopColor: "#721996"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_675_3719",
    x1: 39.8602,
    y1: 6.58209,
    x2: 44.8003,
    y2: 9.70627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#850065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1057,
    stopColor: "#8B096B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2769,
    stopColor: "#9A217A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4924,
    stopColor: "#B34893"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7435,
    stopColor: "#D67EB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBDDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_675_3719",
    x1: 43.4312,
    y1: 4.02065,
    x2: 41.2991,
    y2: 7.56672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1382,
    stopColor: "#B58BDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_675_3719",
    x1: 39.34,
    y1: 9.89098,
    x2: 42.7992,
    y2: 4.42092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF8BDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_675_3719",
    x1: 21.4777,
    y1: 49.8711,
    x2: 29.9267,
    y2: 43.7376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0677,
    stopColor: "#FF2300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2079,
    stopColor: "#FF4B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3527,
    stopColor: "#FF6B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5012,
    stopColor: "#FF8500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6547,
    stopColor: "#FF9700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8164,
    stopColor: "#FFA200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_675_3719",
    x1: 21.5522,
    y1: 50.1451,
    x2: 9.25739,
    y2: 63.9972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1037,
    stopColor: "#FFD100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2518,
    stopColor: "#FFBE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4266,
    stopColor: "#FFA000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6217,
    stopColor: "#FF7500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8311,
    stopColor: "#FF3E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_675_3719",
    x1: 23.4085,
    y1: 44.9634,
    x2: 28.3485,
    y2: 48.0876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#BE0709"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2462,
    stopColor: "#C51C21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4378,
    stopColor: "#D13D48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6611,
    stopColor: "#E26B7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9083,
    stopColor: "#F7A6C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBDDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_675_3719",
    x1: 24.86,
    y1: 48.4783,
    x2: 25.118,
    y2: 42.0817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B68BDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.084,
    stopColor: "#B17DDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2567,
    stopColor: "#A765DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3633,
    stopColor: "#A45CDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9403,
    stopColor: "#721996"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_675_3719",
    x1: 23.4085,
    y1: 44.9634,
    x2: 28.3485,
    y2: 48.0876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#850065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1057,
    stopColor: "#8B096B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2769,
    stopColor: "#9A217A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4924,
    stopColor: "#B34893"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7435,
    stopColor: "#D67EB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBDDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_675_3719",
    x1: 22.8882,
    y1: 48.2723,
    x2: 26.3474,
    y2: 42.8023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF8BDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_675_3719",
    x1: 25.6484,
    y1: 41.6015,
    x2: 23.5162,
    y2: 45.1477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1382,
    stopColor: "#B58BDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_675_3719",
    x1: 27.5259,
    y1: 42.7304,
    x2: 25.3937,
    y2: 46.2765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1382,
    stopColor: "#B58BDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeeklyChallenge);
export default __webpack_public_path__ + "static/media/weeklyChallenge.83d5d6b24fa0c9d8e82414bb208de2d9.svg";
export { ForwardRef as ReactComponent };